export interface paths {
  '/Tools/SmartFlowReporting/GetSmartFlowReportsExcelFile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Gets smart flow reports as an Excel file.
     * @description This endpoint will return smart flow reports for the given contact ids and/or account numbers with an optional time frame as an Excel file download.
     */
    get: operations['GetSmartFlowReportsExcelFile'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Tools/SmartFlowReporting/GetSmartFlowReports': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Gets a list of smart flow reports.
     * @description This endpoint will return smart flow reports for the given contact ids and / or account numbers with an optional time frame
     */
    get: operations['GetSmartFlowReports'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Tools/SetTemporaryPassword': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Set a temporary password for a customers account.
     * @description This endpoint will return a temporary password for a customers account, this overwrites their old password and should be changed by the customer as soon as possible.
     */
    post: operations['SetTemporaryPassword'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Tools/GetCustomerReport': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a list of customer reports that match a given search phrase and type.
     * @description This endpoint will return a list of customer reports retrieved from our REST database containing details about the customer, their brand, username and other information based on a given search phrase and type.
     */
    get: operations['GetCustomerReport'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/SmartOrder/GetFmsOptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieve available FMS options.
     * @description This endpoint returns a list of Financial Management System (FMS) options available for selection.
     */
    get: operations['GetFmsOptions'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Reviews/{itemCode}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves product reviews for the specified item code.
     * @description This endpoint fetches product reviews from Trustpilot for a given item code.
     */
    get: operations['GetProductReviews'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/QuickOrder/{guid}/UpdateItems': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Gets the quick order.
     * @description This endpoint gets the quick order of the provided id or returns a new one if none is passed or id does not exist.
     */
    patch: operations['UpdateQuickOrderItems'];
    trace?: never;
  };
  '/QuickOrder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Gets the quick order.
     * @description This endpoint gets the quick order of the provided id or returns a new one if none is passed or id does not exist.
     */
    get: operations['GetQuickOrder'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/QuickOrder/{guid}/Clear': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Clear the quick order.
     * @description This endpoint clears all the items from the quick order of the provided Guid.
     */
    delete: operations['ClearQuickOrder'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/QuickOrder/{guid}/AddFromFile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add items to the quick order from a file.
     * @description This endpoint adds items to the quick order from the provided csv or excel file.
     */
    post: operations['AddToQuickOrderFromFile'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/QuickOrder/{guid}/AddItems': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add items to the quick order.
     * @description This endpoint adds items to the quick order of the provided id.
     */
    post: operations['AddQuickOrderItems'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/PunchOutSetupRequest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Process PunchOut setup request
     * @description Accepts cXML PunchOut setup request and returns JSON response with cXML as a property
     */
    post: operations['PunchOut Setup Request'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/SavePunchOutSessionTokenToPurchaseOrder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Save PunchOut session token to purchase order
     * @description Associates a PunchOut session token with a purchase order basket for the specified website and SAP contact
     */
    post: operations['Save PunchOut Session Token to Purchase Order'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/UpdatePunchOutBasketStatus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update PunchOut basket status to Punched Out
     * @description Updates a PunchOut basket status to Punched Out and resets the basketid to allow a new basket on next punch in
     */
    post: operations['Update PunchOut basket status to Punched Out'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/GetPunchOutUserDetails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get PunchOut user details
     * @description Retrieves the user details needed for PunchOut login
     */
    get: operations['Get PunchOut User Details'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/GetPunchOutSessionToken': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get PunchOut session token
     * @description Retrieves a PunchOut session token based on the provided session ID
     */
    get: operations['Get PunchOut Session Token'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/PunchOut/GetPunchOutOrderResponse': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Process PunchOut setup request
     * @description Accepts cXML PunchOut setup request and returns JSON response with cXML as a property
     */
    get: operations['Get PunchOut Order Response'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/ProductsILove/SetProductsILove': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sets Products I Love for a given user.
     * @description This endpoint will set Products I Love for logged in and logged out customers
     */
    post: operations['SetProductsILove'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/ProductsILove/MergeProductsILove': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Merge Logged out and Logged in Products I Love.
     * @description Merge Logged out and Logged in Products I Love.
     */
    post: operations['MergeProductsILove'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/ProductsILove/GetProductsILove': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Gets all ProductsILove for a given User or from cookie for logged out user.
     * @description This endpoint will get all ProductsILove from the users cookie or from the DB
     */
    get: operations['GetProductsILove'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/Category/{categoryId}/Sitemap': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of products for the specified category (and subcategories under it) for the sitemap.
     * @description This endpoint retrieves a list of all products for a specified category Id.
     */
    get: operations['GetSitemapCategoryProducts'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/Search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of products with faceted navigation as a result for the specified search-phrase.
     * @description This endpoint retrieves a paginated list of products for a specified search phrase, including facets for filtering, sort options, and detailed product information. Product pricing etc can be personalized with contact ID and username.
     */
    get: operations['GetProductsBySearchPhrase'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/Search/AutoComplete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves a list of products with search suggestions for the current search term.
     * @description This endpoint retrieves a small list of product based on the current search term alongside suggested search terms.
     */
    get: operations['GetProductsBySearchAutoComplete'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/ByItemCodes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves a list of products for the specified item codes.
     * @description This endpoint retrieves a list of products for a specified item coded. Optionally, contact ID can be provided for specific user pricing and restrictions.
     */
    get: operations['GetProducts'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/{itemCode}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves product details for the specified item code.
     * @description This endpoint retrieves the product details for a specified item code. Optionally, contact ID can be provided for additional filtering.
     */
    get: operations['GetProductDetails'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/LandingPage/{landingPageName}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of products for the specified landing page with faceted navigation.
     * @description This endpoint retrieves a paginated list of products for a specified landing page, including facets for filtering, sort options, and detailed product information. Product pricing etc can be personalized with contact ID and username.
     */
    get: operations['GetLandingPageProducts'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/Category/{categoryId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of products for the specified category with faceted navigation.
     * @description This endpoint retrieves a paginated list of products for a specified category ID, including facets for filtering, sort options, and detailed product information. Product pricing etc can be personalized with contact ID and username.
     */
    get: operations['GetCategoryProducts'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Products/Basket/{purchaseOrderId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of products for the specified basket.
     * @description This endpoint retrieves the list of products for a specified purchase order ID. Optionally, contact ID can be provided for additional filtering.
     */
    get: operations['GetBasketProductsDetails'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Notifications/InStock/{itemCode}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sets a in stock notification for the email and item code
     * @description This endpoint sets up a notification email to be sent to the given email when the given product is in stock.
     */
    post: operations['SetInStockNotification'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Notifications/Process': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Processes in stock notifications.
     * @description This endpoint checks all pending in stock notifications for products that are now in stock and sends an email marking them as notified
     */
    post: operations['ProcessInStockNotifications'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Notifications/{contactId}/Calendar-Prompt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get calendar prompt details for a contact.
     * @description Returns calendar prompt visibility and content for a given ContactId and Website.
     */
    get: operations['GetShowCalendarPrompt'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Notifications/NewsLetterSignup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Signs up customer to news letter
     * @description This endpoint allows sign up customers to news letter.
     */
    post: operations['AddUserToNewsletter'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/MyList/{contactId}/GetUserListsWithProductStatus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get all My Lists for a user with included products only
     * @description Returns all My Lists for the user, showing only the catalogueRefs that are actually included in each list.
     */
    get: operations['GetUserListsWithProductStatus'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/MyList/{contactId}/AllItems': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get all My Lists with products for a user
     * @description Returns all My Lists for the user, including full product entries.
     */
    get: operations['GetAllMyListsWithItems'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/MyList/DeleteItems': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deletes items from the specified my list.
     * @description This endpoint allows deleting one or more items from a user's my list. Deletion can be done via MyListItemId or CatalogueRef.
     */
    post: operations['DeleteMyListItems'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/MyList/AddToMyList': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Adds order lines to the specified basket.
     * @description This endpoint allows adding multiple order lines to a specified basket. If the item already exists in the basket, it will add to the quantity.
     */
    post: operations['AddToMyList'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitOverprintingForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit the form data from the overprinting forms
     * @description Submitted data from the overprinting forms is validated and sent along to the relevant people
     */
    post: operations['SubmitOverprintingForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitNpsFeedbackForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit the form data from the NPS feedback forms
     * @description Submitted data from the NPS feedback forms is validated and sent along to the relevant people
     */
    post: operations['SubmitNpsFeedbackForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitLeadGenerationForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit the form data from the lead generation forms
     * @description Submitted data from the lead generation forms is validated and sent along to the relevant people
     */
    post: operations['SubmitLeadGenerationForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitFmsSetupForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request to set the FMS (Financial Management System) for the specified account.
     * @description This endpoint allows requesting to set the FMS for an account based on the provided request data.
     */
    post: operations['SubmitFmsSetupForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitCreditApplicationForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit the form data from the credit application forms
     * @description Submitted data from the credit application forms is validated and sent along to the relevant people
     */
    post: operations['SubmitCreditApplicationForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Forms/SubmitContactUsForm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit the form data from the contact us forms
     * @description Submitted data from the contact us forms is validated and sent along to the relevant people
     */
    post: operations['SubmitContactUsForm'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Customer/TransactionData': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get customer transaction data.
     * @description Returns transaction data for the specified Website and either ContactId or CountryCode.
     */
    get: operations['GetCustomerTransactionData'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/customer/{contactId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get customer details by contact ID.
     * @description Returns the customer details for the specified ContactId and Website.
     */
    get: operations['GetCustomerByContactId'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Offer/Convert': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Converts an offer.to a purchase order
     * @description This endpoint converts an offer.to a purchase order, registers the order with checkout and returns the checkout url
     */
    post: operations['Convert'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Category/Sitemap': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of categories for the sitemap.
     * @description This endpoint retrieves the list of sitemap categories for a specified website.
     */
    get: operations['SitemapCategory'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Category': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the list of categories.
     * @description This endpoint retrieves the list of categories for a specified website.
     */
    get: operations['GetCategory'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/OrderLine': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Deletes order lines from the specified basket.
     * @description This endpoint allows deleting multiple order lines from a specified basket. If the item does not exist in the basket, it will be ignored.
     */
    delete: operations['DeleteOrderLine'];
    options?: never;
    head?: never;
    /**
     * Updates order lines for the specified basket.
     * @description This endpoint allows updating order lines for a specified basket. If an order line does not exist, it will be ignored. If the quantity is 0 it will delete the order line
     */
    patch: operations['UpdateOrderLine'];
    trace?: never;
  };
  '/Basket/{basketId}/Share': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Share the specified basket.
     * @description This endpoint allows sharing a specified basket.
     */
    post: operations['Share'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/PurchaseOrderNo': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Deletes the purchase order number from the specified basket.
     * @description This endpoint allows deleting the purchase order number from a specified basket. If the purchase order number does not exist in the basket, it will be ignored.
     */
    delete: operations['DeletePurchaseOrderNo'];
    options?: never;
    head?: never;
    /**
     * Sets a purchase order number for the specified basket.
     * @description This endpoint allows setting a purchase order number for a specified basket. If the purchase order number already exists, it will be updated.
     */
    patch: operations['SetPurchaseOrderNo'];
    trace?: never;
  };
  '/Basket/{basketId}/PromoCode': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Deletes a promo code from the specified basket.
     * @description This endpoint allows deleting a promo code from a specified basket. If the promo code does not exist in the basket, it will be ignored.
     */
    delete: operations['DeletePromoCode'];
    options?: never;
    head?: never;
    /**
     * Sets a promo code for the specified basket.
     * @description This endpoint allows setting a promo code for a specified basket. If the promo code already exists, it will be updated.
     */
    patch: operations['SetPromoCode'];
    trace?: never;
  };
  '/Basket/{basketId}/SetCheckoutSims': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sets checkout data.
     * @description Sets the data required for checkout and returns a GUID required to access the checkout.
     */
    post: operations['SetCheckoutSims'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/SetCheckoutData': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sets checkout data.
     * @description Sets the data required for checkout and returns a GUID required to access the checkout.
     */
    post: operations['SetCheckoutData'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/ReplaceOrderLine': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Replaces order lines for the specified basket.
     * @description This endpoint allows replacing order lines from one product to another for a specified basket retaining the quantities.
     */
    post: operations['ReplaceOrderLine'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/OrderSimulate/GetStatus': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the order simulate status for a Task ID.
     * @description This endpoint retrieves the order simulate status for a given task ID that was generated on a simulation trigger.
     */
    get: operations['GetOrderSimulateStatus'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/OrderSimulate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['OrderSimulate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketIdToImport}/Import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Retrieves the basket details for the specified basket ID and/or contact ID.
     * @description This endpoint retrieves the basket details for a specified basket ID and/or contact ID. If a contact id is provided it will check for any incomplete basket for the user, if no basket id was provide it will return this, if a basket id was provided it will import the two baskets together and return. If no contact id was provided it will return the basket for the basket id if valid.
     */
    post: operations['ImportBasket'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/ExcelDownload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the basket as an excel file
     * @description This endpoint retrieves the basket items, price and summary details and returns them as an excel file
     */
    get: operations['GetBasketExcelFile'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieves the basket details for the specified basket ID and/or contact ID.
     * @description This endpoint retrieves the basket details for a specified basket ID and/or contact ID. If a contact id is provided it will check for any incomplete basket for the user, if no basket id was provide it will return this, if a basket id was provided it will merge the two baskets together and return. If no contact id was provided it will return the basket for the basket id if valid.
     */
    get: operations['GetBasket'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/Cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Empties a basket.
     * @description Sets the given basket status to cancelled. This will make existing basket id not being available anymore. Call GetBasket to fetch new basket Id.
     */
    post: operations['Cancel'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/AddQuickOrder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Adds the items from a specified quick order to the specified basket.
     * @description This endpoint gets the quick order and adds each item to a specified basket. If the item already exists in the basket, it will add to the quantity.
     */
    post: operations['AddQuickOrderToBasket'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Basket/{basketId}/AddOrderLine': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Adds order lines to the specified basket.
     * @description This endpoint allows adding multiple order lines to a specified basket. If the item already exists in the basket, it will add to the quantity.
     */
    post: operations['AddOrderLine'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Authentication/PasswordReset': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request password reset for the customer
     * @description This endpoint allows customers to request password reset link be sent via email.
     */
    post: operations['PasswordReset'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Authentication/PasswordResetSet': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Set a new password via Reset password email route
     * @description This endpoint allows user to choose and set a new password as request via password reset email.
     */
    post: operations['PasswordResetSet'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Authentication/PasswordResetValidate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Checks validity of the provided token for Reset password email scenario
     * @description This endpoint allows application to validate a token provided in the email before user can choose a new password.
     */
    post: operations['PasswordResetValidate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Authentication/SetChatRestoreId': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * This is an endpoint we provide to freshchat so that we can store the guid for their chat history.
     * @description This is an endpoint we provide to freshchat so that we can store the guid for their chat history.
     */
    post: operations['SetChatRestoreId'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/Authentication/AuthenticateCustomer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Authenticates a customer with the provided credentials.
     * @description This endpoint authenticates a customer using the provided username and password. Optionally, the customer can choose to stay signed in.
     */
    post: operations['AuthenticateCustomer'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    ErrorResponse: {
      /**
       * Format: int32
       * @default 400
       */
      statusCode: number;
      /** @default One or more errors occurred! */
      message: string;
      errors: {
        [key: string]: string[];
      };
    };
    ProblemDetails: {
      /** @default https://www.rfc-editor.org/rfc/rfc7231#section-6.5.1 */
      type: string;
      /** @default One or more validation errors occurred. */
      title: string;
      /**
       * Format: int32
       * @default 400
       */
      status: number;
      /** @default /api/route */
      instance: string;
      /** @default 0HMPNHL0JHL76:00000001 */
      traceId: string;
      detail?: string | null;
      errors: components['schemas']['ProblemDetails_Error'][];
    };
    ProblemDetails_Error: {
      /** @default Error or field name */
      name: string;
      /** @default Error reason */
      reason: string;
      code?: string | null;
      severity?: string | null;
    };
    GetSmartFlowReportsRequest: Record<string, never>;
    /** @enum {string} */
    Website: Website;
    GetSmartFlowReportsResponse: {
      orders: components['schemas']['SmartFlowReport'][];
    };
    SmartFlowReport: {
      orderHeader: components['schemas']['SmartFlowReportOrderHeader'];
      orderItems: components['schemas']['SmartFlowReportOrderItem'][];
      approvers: components['schemas']['SmartFlowReportApproverRow'][];
      auditTrail: components['schemas']['SmartFlowReportAuditTrailRow'][];
    };
    SmartFlowReportOrderHeader: {
      /** Format: int64 */
      orderId: number;
      sapBrandId: string;
      customerRef: string;
      email: string;
      username: string;
      contactTitle: string;
      contactForename: string;
      contactSurname: string;
      accountNo: string;
      /** Format: int32 */
      sapContactId: number;
      sapDeliveryAddressId: string;
      promotionCode: string;
      telephoneNumber: string;
      webOrderReference: string;
      sapOrderReference: string;
      /** Format: int32 */
      deliveryPreference: number;
      /** Format: date-time */
      scheduledDeliveryDate?: string | null;
      customerInstructions: string;
      orderStatus: string;
      /** Format: int32 */
      orderStatusId: number;
      /** Format: decimal */
      netOrderValue: number;
      /** Format: decimal */
      grossOrderValue: number;
      /** Format: decimal */
      promotionValue: number;
      /** Format: decimal */
      totalDiscountValue: number;
      /** Format: date-time */
      dateCreated: string;
      /** Format: date-time */
      dateModified: string;
      /** Format: byte */
      timestamp: string;
      /** Format: guid */
      orderGuid?: string | null;
      /** Format: int32 */
      orderTypeId?: number | null;
      establishmentName: string;
      contactEmail: string;
      /** Format: int32 */
      websiteId?: number | null;
      currency: string;
    };
    SmartFlowReportOrderItem: {
      itemCode: string;
      description: string;
      /** Format: int32 */
      quantity: number;
      /** Format: decimal */
      netLineValue: number;
      /** Format: decimal */
      grossLineValue: number;
      /** Format: date-time */
      dateCreated: string;
    };
    SmartFlowReportApproverRow: {
      orderId: string;
      /** Format: int32 */
      sapContactId: number;
      emailAddress: string;
      approverName: string;
      /** Format: date-time */
      dateCreated: string;
      /** Format: date-time */
      dateAuthorised?: string | null;
    };
    SmartFlowReportAuditTrailRow: {
      orderId: string;
      /** Format: int32 */
      sapContactId: number;
      emailAddress: string;
      auditMessage: string;
      /** Format: date-time */
      dateCreated: string;
    };
    SetTemporaryPasswordResponse: {
      customerEmail: string;
      temporaryPassword: string;
    };
    SetTemporaryPasswordRequest: {
      employeeName: string;
      /** Format: int32 */
      sapContactId: number;
      website: components['schemas']['Website'];
    };
    GetCustomerReportResponse: {
      customerReports?: components['schemas']['CustomerReport'][] | null;
    };
    CustomerReport: {
      /** Format: int32 */
      fbrandID: number;
      /** Format: int32 */
      sapContactID: number;
      userName: string;
      name: string;
      /** Format: date-time */
      dateContactCreated: string;
      /** Format: date-time */
      dateContactModified: string;
      /** Format: int32 */
      establishmentId: number;
      accountNo: string;
      contactName: string;
      /** Format: date-time */
      dateEstablishmentCreated: string;
      /** Format: date-time */
      dateEstablishmentModified: string;
    };
    GetCustomerReportRequest: Record<string, never>;
    /** @enum {string} */
    SearchTypeEnum: SearchTypeEnum;
    GetFmsOptionsResponse: {
      fmsList: components['schemas']['FMS'][];
      success: boolean;
      message: string;
    };
    FMS: {
      code: string;
      name: string;
    };
    GetFmsOptionsRequest: Record<string, never>;
    GetProductReviewsByItemCodeResponse: {
      reviews?: components['schemas']['Reviews'] | null;
    };
    Reviews: {
      productReviews: components['schemas']['ProductReview'][];
      productReviewSummary: components['schemas']['ProductReviewSummary'];
    };
    ProductReview: {
      /** Format: date-time */
      createdAt: string;
      userFriendlyCreatedDate: string;
      /** Format: decimal */
      stars: number;
      content: string;
      consumerName: string;
      firstCompanyComment: components['schemas']['FirstCompanyComment'];
      attributeRatings: components['schemas']['AttributeRatings'][];
      attachments: components['schemas']['Attachment'][];
    };
    FirstCompanyComment: {
      comment: string;
      /** Format: date-time */
      createdAt: string;
      userFriendlyCreatedDate: string;
    };
    AttributeRatings: {
      attributeName: string;
      attributeType: string;
      /** Format: int32 */
      rating: number;
    };
    Attachment: {
      id: string;
      state: string;
      processedFiles: components['schemas']['ProcessedFile'][];
    };
    ProcessedFile: {
      dimension: string;
      mimeType: string;
      url: string;
    };
    ProductReviewSummary: {
      sku: string;
      /** Format: double */
      starsAverage: number;
      numberOfReviews: components['schemas']['ReviewCount'];
    };
    ReviewCount: {
      /** Format: int32 */
      total: number;
      /** Format: int32 */
      oneStar: number;
      /** Format: int32 */
      twoStars: number;
      /** Format: int32 */
      threeStars: number;
      /** Format: int32 */
      fourStars: number;
      /** Format: int32 */
      fiveStars: number;
    };
    GetProductReviewsByItemCodeRequest: Record<string, never>;
    UpdateQuickOrderItemsResponse: {
      message: string;
      updatedItems: components['schemas']['UpdatedItem'][];
    };
    UpdatedItem: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
      message: string;
    };
    UpdateQuickOrderItemsRequest: {
      website: components['schemas']['Website'];
      itemsToUpdate: components['schemas']['QuickOrderItemRequest'][];
      /** Format: int32 */
      contactId?: number | null;
    };
    QuickOrderItemRequest: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
    };
    GetQuickOrderResponse: {
      quickOrder: components['schemas']['QuickOrderDetails'];
    };
    QuickOrderDetails: {
      /** Format: guid */
      guid: string;
      products: components['schemas']['QuickOrderItem'][];
      removedProducts: components['schemas']['InvalidItemDetails'][];
      /** Format: decimal */
      totalExcVat: number;
      /** Format: decimal */
      totalIncVat: number;
    };
    QuickOrderItem: {
      product: components['schemas']['ProductDetails'];
      /** Format: int32 */
      quantity: number;
      /** Format: decimal */
      linePriceIncVat: number;
      /** Format: decimal */
      linePriceExcVat: number;
    };
    ProductDetails: components['schemas']['Product'] & {
      imagesList: components['schemas']['ProductImage'][];
      media: components['schemas']['ProductMedia'][];
      reasonsToLove: string;
      hasPriceBreak: boolean;
      priceBreaks: components['schemas']['ProductPriceBreak'][];
      /** Format: int32 */
      priceBreakMinUnits: number;
      /** Format: int32 */
      category1Id: number;
      /** Format: int32 */
      category2Id: number;
      /** Format: int32 */
      category3Id?: number | null;
      alternativeProducts?: components['schemas']['Product'][] | null;
      productLessons: components['schemas']['ProductLessons'];
      metaTagDescription: string;
      productFeatures: components['schemas']['ProductFeature'][];
    };
    ProductImage: {
      name: string;
      /** Format: int32 */
      index: number;
    };
    ProductMedia: {
      /** Format: int64 */
      productMediaID: number;
      value: string;
      mediaType: components['schemas']['ProductMediaType'];
      title: string;
      urlEncodedDocumentName: string;
    };
    /** @enum {string} */
    ProductMediaType: ProductMediaType;
    ProductPriceBreak: {
      /** Format: int32 */
      units: number;
      /** Format: decimal */
      price: number;
      /** Format: decimal */
      priceIncVat: number;
      /** Format: decimal */
      savings: number;
      /** Format: decimal */
      savingsIncVat: number;
      /** Format: decimal */
      savingsPercentage: number;
    };
    Product: {
      /** Format: int32 */
      productId: number;
      /** Format: int32 */
      fbrandProductId: number;
      itemCode: string;
      catalogueRef: string;
      productName: string;
      imageId: string;
      urlPath: string;
      description: string;
      /** Format: decimal */
      priceIncVat: number;
      /** Format: decimal */
      priceExcVat: number;
      /** Format: decimal */
      wasPriceExcVat?: number | null;
      /** Format: decimal */
      wasPriceIncVat?: number | null;
      /** Format: decimal */
      savingsPercentage?: number | null;
      isDirectDelivery: boolean;
      directDeliveryText: string;
      isFavourite?: boolean | null;
      isContractPrice: boolean;
      isDiscountPrice: boolean;
      isRestricted: boolean;
      isTemporarilyUnavailable: boolean;
      isUnitPriceDisabled: boolean;
      isPriceBreakPrice: boolean;
      brandName: string;
      /** Format: int32 */
      minOrderQuantity: number;
      /** Format: int32 */
      baseQuantity: number;
      roundels: components['schemas']['Roundel'][];
      stockInfo: components['schemas']['StockInfo'];
      alternativeProductType: components['schemas']['AlternativeProductType'];
      /** Format: decimal */
      alternativeSavings?: number | null;
      reviews?: components['schemas']['Reviews'] | null;
      /** Format: int32 */
      parentFbrandProductId?: number | null;
      sliLogUrl?: string | null;
      isVariant: boolean;
      isVariantHeader: boolean;
      variantHeader?: string | null;
      isDiscountExcluded: boolean;
      variants?: components['schemas']['VariantType'][] | null;
      isThirdPartyDDelivery: boolean;
      currency: string;
    };
    Roundel: {
      name: string;
      text: string;
      fileName: string;
    };
    StockInfo: {
      /** Format: int64 */
      stockLevel?: number | null;
      stockStatus: components['schemas']['StockStatus'];
      isInStock: boolean;
      isDelayedStock: boolean;
      isOutOfStock: boolean;
      isStockRelevant: boolean;
      expectedBackInStockMessage: string;
      /** Format: date-time */
      preOrderDate: string;
      isPreOrder: boolean;
      isBackInStockNotifyEnabled: boolean;
      inStockDeliveryMessage: string;
      thirdPartyDirectDeliveryMessage: string;
    };
    /** @enum {string} */
    StockStatus: StockStatus;
    /** @enum {string} */
    AlternativeProductType: AlternativeProductType;
    VariantType: {
      name: string;
      variantValues: components['schemas']['VariantValue'][];
    };
    VariantValue: {
      name: string;
      catalogueRef: string;
      itemCode: string;
      isSelected: boolean;
      isValidCombination: boolean;
      imageId: string;
      baseColour?: string | null;
    };
    ProductLessons: {
      lessons: components['schemas']['Lesson'][];
      searchUrl: string;
      /** Format: int32 */
      additionalLessonCount: number;
      hasProductLessons: boolean;
    };
    Lesson: {
      id: string;
      name: string;
      lessonUrl: string;
      keyStages: string[];
      imageUrl: string;
    };
    ProductFeature: {
      name: string;
      value: string;
    };
    InvalidItemDetails: {
      catalogueRef: string;
      reason: components['schemas']['Reason'];
    };
    /** @enum {string} */
    Reason: Reason;
    GetQuickOrderRequest: Record<string, never>;
    ClearQuickOrderRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
    };
    AddToQuickOrderFromFileResponse: {
      addedItems: string[];
      invalidItems: components['schemas']['InvalidItemDetails'][];
    };
    AddToQuickOrderFromFileRequest: {
      website: components['schemas']['Website'];
      /** Format: binary */
      file: string;
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    AddQuickOrderItemsResponse: {
      addedItems: string[];
      invalidItems: components['schemas']['InvalidItemDetails'][];
    };
    AddQuickOrderItemsRequest: {
      website: components['schemas']['Website'];
      itemsToAdd: components['schemas']['QuickOrderItemRequest'][];
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    PunchOutSetupRequestResponse: {
      cXml: string;
      success: boolean;
    };
    /** @example {
     *       "header": null,
     *       "request": null,
     *       "lang": null,
     *       "payloadID": null,
     *       "timestamp": null
     *     } */
    PunchOutSetupRequestRequest: {
      website: components['schemas']['Website'];
      cXmlString: string;
      baseUrl: string;
    };
    SavePunchOutSessionTokenToPurchaseOrderResponse: {
      success: boolean;
    };
    /** @example {
     *       "website": 5,
     *       "basketId": "12345678-1234-1234-1234-123456789012",
     *       "sapContactId": 12345,
     *       "punchOutSessionToken": {
     *         "id": "115c8def-313f-4f3e-85fa-a0d271eb77a8",
     *         "userName": "punchout_user",
     *         "punchOutAdditionalDetails": {
     *           "buyerCookie": "buyer123cookie",
     *           "buyerCredential": {
     *             "identity": "buyer_identity",
     *             "domain": "buyer.example.com",
     *             "sharedSecret": "buyer_shared_secret"
     *           },
     *           "exchangeCredential": {
     *             "identity": "exchange_identity",
     *             "domain": "exchange.example.com",
     *             "sharedSecret": "exchange_shared_secret"
     *           },
     *           "exchangeName": "Sample Exchange",
     *           "exchangeType": 1,
     *           "browserFormPostUrl": "https://example.com/punchout/return",
     *           "shippingDetails": {
     *             "shippingTotal": 15.99,
     *             "shippingTotalVat": 3.2,
     *             "shippingTotalVatStatus": "Taxable"
     *           },
     *           "exitUrl": null
     *         },
     *         "issuedOn": "2025-10-08T13:16:25.6233467Z",
     *         "expiryOn": "2025-10-08T21:16:25.6233622Z"
     *       }
     *     } */
    SavePunchOutSessionTokenToPurchaseOrderRequest: {
      website: components['schemas']['Website'];
      /** Format: guid */
      basketId: string;
      /** Format: int32 */
      sapContactId: number;
      punchOutSessionToken: components['schemas']['PunchOutSessionToken'];
    };
    PunchOutSessionToken: {
      /** Format: guid */
      id: string;
      userName: string;
      punchOutAdditionalDetails: components['schemas']['PunchOutAdditionalDetails'];
      /** Format: date-time */
      issuedOn: string;
      /** Format: date-time */
      expiryOn: string;
    };
    PunchOutAdditionalDetails: {
      buyerCookie: string;
      buyerCredential: components['schemas']['Credential'];
      exchangeCredential: components['schemas']['Credential'];
      exchangeName: string;
      exchangeType: components['schemas']['PunchOutExchange'];
      browserFormPostUrl: string;
      shippingDetails: components['schemas']['PunchOutShippingDetails'];
      exitUrl: string;
    };
    Credential: {
      identity: string;
      domain: string;
      sharedSecret: string;
    };
    /** @enum {integer} */
    PunchOutExchange: PunchOutExchange;
    PunchOutShippingDetails: {
      /** Format: decimal */
      shippingTotal?: number | null;
      /** Format: decimal */
      shippingTotalVat?: number | null;
      shippingTotalVatStatus: string;
    };
    UpdatePunchOutBasketStatusResponse: {
      success: boolean;
    };
    /** @example {
     *       "website": 5,
     *       "basketId": "12345678-1234-1234-1234-123456789012",
     *       "sapContactId": 12345
     *     } */
    UpdatePunchOutBasketStatusRequest: {
      website: components['schemas']['Website'];
      /** Format: guid */
      basketId: string;
      /** Format: int32 */
      sapContactId: number;
    };
    GetPunchOutUserDetailsResponse: {
      userName: string;
      accountNo: string;
      /** Format: int32 */
      sapContactId: number;
      firstName: string;
      lastName: string;
      countryCode: string;
      landingPage: string;
      priceGroupCode: string;
      priceGroupDescription: string;
      isPunchOut: boolean;
      mapToLimitedUomList: boolean;
      success: boolean;
    };
    GetPunchOutUserDetailsRequest: Record<string, never>;
    GetPunchOutSessionTokenResponse: {
      punchOutSessionToken: components['schemas']['PunchOutSessionToken'];
    };
    GetPunchOutSessionTokenRequest: Record<string, never>;
    GetPunchOutOrderResponseResponse: {
      cxml: string;
      success: boolean;
    };
    GetPunchOutOrderResponseRequest: Record<string, never>;
    SetProductsILoveResponse: {
      success: boolean;
      message: string;
      productsILoveCookieValues?: string[] | null;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": null,
     *       "productsILoveCookieValues": [
     *         "HP00056675"
     *       ],
     *       "catalogRef": "HP00056676",
     *       "isRemove": false
     *     } */
    SetProductsILoveRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
      productsILoveCookieValues?: string[] | null;
      catalogRef: string;
      isRemove: boolean;
    };
    MergeProductsILoveResponse: {
      success: boolean;
    };
    /** @example {
     *       "productsILoveCookieValues": [
     *         "HP00056675"
     *       ],
     *       "contactId": 12345,
     *       "website": 5
     *     } */
    MergeProductsILoveRequest: {
      productsILoveCookieValues: string[];
      /** Format: int32 */
      contactId: number;
      website: components['schemas']['Website'];
    };
    GetProductsILoveResponse: {
      productsILove: string[];
    };
    GetProductsILoveRequest: Record<string, never>;
    GetSitemapCategoryProductsResponse: {
      products: components['schemas']['SitemapProduct'][];
      currency: string;
      isTransactional: boolean;
    };
    SitemapProduct: {
      itemCode: string;
      catalogueRef: string;
      productName: string;
      urlPath: string;
      /** Format: date-time */
      lastModifiedOn: string;
      changeFrequency: components['schemas']['ChangeFrequency'];
    };
    /** @enum {integer} */
    ChangeFrequency: ChangeFrequency;
    GetSitemapCategoryProductsRequest: Record<string, never>;
    GetProductsBySearchPhraseResponse: {
      sliUserId?: string | null;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      offset: number;
      /** Format: int32 */
      limit: number;
      facets: components['schemas']['ProductFacet'][];
      facetSliders?: components['schemas']['ProductFacetSlider'][] | null;
      products: components['schemas']['Product'][];
      sortOptions: components['schemas']['SortOption'][];
      suggestions?: string[] | null;
      spellingSuggestion?: string | null;
      wasAutoCorrected: boolean;
      autoCorrectedPhrase?: string | null;
      originalSearchPhrase?: string | null;
      sliMerch?: components['schemas']['Merch'] | null;
      sliTrackingCode?: string | null;
      currency: string;
      isTransactional: boolean;
    };
    ProductFacet: {
      key: string;
      name: string;
      facetValues: components['schemas']['ProductFacetValue'][];
    };
    ProductFacetValue: {
      key: string;
      name: string;
      /** Format: int32 */
      count: number;
      selected: boolean;
    };
    ProductFacetSlider: {
      key: string;
      name: string;
      /** Format: int32 */
      min: number;
      /** Format: int32 */
      max: number;
      selected: boolean;
      /** Format: int32 */
      selectedMin?: number | null;
      /** Format: int32 */
      selectedMax?: number | null;
    };
    SortOption: {
      key: string;
      name: string;
      selected: boolean;
    };
    Merch: {
      jumpUrl: string;
      logUrl: string;
      banners: components['schemas']['Banner'][];
    };
    Banner: {
      name: string;
      placement: string;
      type: string;
      content: string;
      logUrl: string;
    };
    GetProductsBySearchPhraseRequest: Record<string, never>;
    GetProductsBySearchAutoCompleteResponse: {
      sliUserId?: string | null;
      products: components['schemas']['Product'][];
      searchSuggestions: components['schemas']['SearchSuggestion'][];
      currency: string;
      isTransactional: boolean;
    };
    SearchSuggestion: {
      suggestion: string;
      logUrl: string;
    };
    GetProductsBySearchAutoCompleteRequest: Record<string, never>;
    GetProductsByItemCodesResponse: {
      products: components['schemas']['Product'][];
      currency: string;
      isTransactional: boolean;
    };
    GetProductsByItemCodesRequest: Record<string, never>;
    GetProductDetailsByItemCodeResponse: {
      product: components['schemas']['ProductDetails'];
      currency: string;
      isTransactional: boolean;
    };
    GetProductDetailsByItemCodeRequest: Record<string, never>;
    GetLandingPageProductsResponse: {
      sliUserId?: string | null;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      offset: number;
      /** Format: int32 */
      limit: number;
      facets: components['schemas']['ProductFacet'][];
      facetSliders?: components['schemas']['ProductFacetSlider'][] | null;
      products: components['schemas']['Product'][];
      sortOptions: components['schemas']['SortOption'][];
      suggestions?: string[] | null;
      sliTrackingCode?: string | null;
      sliMerch?: components['schemas']['Merch'] | null;
      landingPageDetails: components['schemas']['LandingPageDetails'];
      currency: string;
      isTransactional: boolean;
    };
    LandingPageDetails: {
      header: string;
      metaData: components['schemas']['MetaData'];
    };
    MetaData: {
      title: string;
      description: string;
      robots: components['schemas']['Robots'];
    };
    Robots: {
      index: boolean;
      follow: boolean;
    };
    GetLandingPageProductsRequest: Record<string, never>;
    GetCategoryProductsResponse: {
      sliUserId?: string | null;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      offset: number;
      /** Format: int32 */
      limit: number;
      facets: components['schemas']['ProductFacet'][];
      facetSliders?: components['schemas']['ProductFacetSlider'][] | null;
      products: components['schemas']['Product'][];
      sortOptions: components['schemas']['SortOption'][];
      suggestions?: string[] | null;
      sliTrackingCode?: string | null;
      sliMerch?: components['schemas']['Merch'] | null;
      currency: string;
      isTransactional: boolean;
    };
    GetCategoryProductsRequest: Record<string, never>;
    GetBasketProductsDetailsResponse: {
      products: components['schemas']['ProductDetails'][];
      currency: string;
      isTransactional: boolean;
    };
    GetBasketProductsDetailsRequest: Record<string, never>;
    SetInStockNotificationRequest: {
      website: components['schemas']['Website'];
      email: string;
      firstName: string;
      lastName: string;
    };
    GetShowCalendarPromptResponse: {
      showPrompt: boolean;
      content: string;
      confirmURL: string;
      useShippingTerminology: boolean;
    };
    GetShowCalendarPromptRequest: Record<string, never>;
    AddUserToNewsletterResponse: {
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "name": "John Doe",
     *       "email": "johndoe@gmail.com",
     *       "contactId": null
     *     } */
    AddUserToNewsletterRequest: {
      website: components['schemas']['Website'];
      name: string;
      email: string;
      /** Format: int32 */
      contactId?: number | null;
    };
    GetUserListsWithProductStatusResponse: {
      userLists: components['schemas']['UserListWithProductStatus'][];
    };
    UserListWithProductStatus: {
      /** Format: int32 */
      listId: number;
      listName: string;
      includedCatalogueRefs: components['schemas']['MyListProductInfo'][];
    };
    MyListProductInfo: {
      /** Format: int32 */
      myListItemId: number;
      catalogueRef: string;
    };
    GetUserListsWithProductStatusRequest: Record<string, never>;
    GetAllMyListsWithItemsResponse: {
      myLists: components['schemas']['MyList'][];
    };
    MyList: {
      /** Format: int32 */
      listId: number;
      listName: string;
      products: components['schemas']['MyListProduct'][];
    };
    MyListProduct: {
      /** Format: int32 */
      myListItemId: number;
      catalogueRef: string;
      /** Format: int32 */
      quantity: number;
    };
    GetAllMyListsWithItemsRequest: Record<string, never>;
    DeleteMyListItemsResponse: {
      success: boolean;
      deletedItems: components['schemas']['DeleteMyListItemResult'][];
      deleteFailedItems: components['schemas']['DeleteMyListItemResult'][];
    };
    DeleteMyListItemResult: {
      /** Format: int32 */
      myListId: number;
      /** Format: int32 */
      myListItemId: number;
    };
    /** @example {
     *       "website": 5,
     *       "itemsToDelete": [
     *         {
     *           "myListId": 1,
     *           "myListItemId": 123,
     *           "catalogueRef": null
     *         },
     *         {
     *           "myListId": 1,
     *           "myListItemId": null,
     *           "catalogueRef": "ABC123"
     *         }
     *       ]
     *     } */
    DeleteMyListItemsRequest: {
      website: components['schemas']['Website'];
      itemsToDelete: components['schemas']['DeleteMyListRequestItem'][];
    };
    DeleteMyListRequestItem: {
      /** Format: int32 */
      myListId: number;
      /** Format: int32 */
      myListItemId?: number | null;
      catalogueRef: string;
    };
    AddToMyListResponse: {
      success: boolean;
      newLists: components['schemas']['NewList'][];
    };
    NewList: {
      /** Format: int32 */
      myListId: number;
      name: string;
      isDefault: boolean;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 4999999,
     *       "items": [
     *         {
     *           "catalogueRef": "catalogueRef1",
     *           "quantity": 1,
     *           "myListId": 1,
     *           "newListName": "",
     *           "isNewList": false,
     *           "setNewListDefault": null
     *         },
     *         {
     *           "catalogueRef": "catalogueRef2",
     *           "quantity": 1,
     *           "myListId": 0,
     *           "newListName": "Test",
     *           "isNewList": true,
     *           "setNewListDefault": null
     *         }
     *       ]
     *     } */
    AddToMyListRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId: number;
      items: components['schemas']['AddToMyListRequestItem'][];
    };
    AddToMyListRequestItem: {
      catalogueRef: string;
      /** Format: int32 */
      quantity: number;
      /** Format: int32 */
      myListId?: number | null;
      newListName?: string | null;
      isNewList: boolean;
      setNewListDefault?: boolean | null;
    };
    SubmitOverprintingFormResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "name": "Jane Teacher",
     *       "email": "jane.teacher@school.com",
     *       "phone": "01234567890",
     *       "schoolName": "Hope Primary School",
     *       "notes": "We need custom printing on our school notebooks",
     *       "formIdentifier": "OverprintingForm",
     *       "pageUrl": "https://example.com/overprinting",
     *       "overprintingFile": null
     *     } */
    SubmitOverprintingFormRequest: {
      website: components['schemas']['Website'];
      name: string;
      /** Format: email */
      email: string;
      phone: string;
      schoolName: string;
      notes: string;
      formIdentifier: string;
      pageUrl: string;
      /** Format: binary */
      overprintingFile: string;
    };
    SubmitNpsFeedbackFormResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "likelyToRecommendRating": 9,
     *       "likelyToRecommendReasons": "Great service and fast delivery",
     *       "overallExperienceRating": 5,
     *       "overallExperienceSuggestions": "Keep up the excellent work",
     *       "easeOfDoingBusinessRating": "Very Difficult",
     *       "easeOfDoingBusinessSuggestions": "The ordering process was smooth",
     *       "brandOfChoiceRating": 5,
     *       "brandOfChoiceReasons": "Reliable and high quality products",
     *       "formIdentifier": "NPS",
     *       "pageUrl": "https://example.com/nps",
     *       "useInMarketing": true,
     *       "contactId": 123456,
     *       "email": null
     *     } */
    SubmitNpsFeedbackFormRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      likelyToRecommendRating: number;
      likelyToRecommendReasons?: string | null;
      /** Format: int32 */
      overallExperienceRating: number;
      overallExperienceSuggestions?: string | null;
      easeOfDoingBusinessRating: string;
      easeOfDoingBusinessSuggestions?: string | null;
      /** Format: int32 */
      brandOfChoiceRating: number;
      brandOfChoiceReasons?: string | null;
      formIdentifier: string;
      pageUrl: string;
      useInMarketing: boolean;
      /** Format: int32 */
      contactId?: number | null;
      email?: string | null;
    };
    SubmitLeadGenerationFormResponse: {
      success: boolean;
      message: string;
    };
    SubmitLeadGenerationFormRequest: {
      website: components['schemas']['Website'];
      fullName: string;
      phone: string;
      /** Format: email */
      email: string;
      establishmentAddress: string;
      establishmentName: string;
      notes?: string | null;
      marketingSignup: boolean;
      webFMSChoice?: string | null;
      otherWebFMSSystem?: string | null;
      formIdentifier: string;
      pageUrl: string;
      isWebFmsForm: boolean;
    };
    SubmitFmsSetupFormResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "fullName": "John Doe",
     *       "establishmentName": "Abc School",
     *       "email": "johndoe@test.com",
     *       "phoneNumber": "1234567890",
     *       "contactId": 123456,
     *       "webFMSChoice": "TestFms",
     *       "otherWebFMSSystem": null,
     *       "pageUrl": "https://example.com/basket"
     *     } */
    SubmitFmsSetupFormRequest: {
      website: components['schemas']['Website'];
      fullName: string;
      establishmentName: string;
      /** Format: email */
      email: string;
      phoneNumber: string;
      /** Format: int32 */
      contactId: number;
      webFMSChoice: string;
      otherWebFMSSystem?: string | null;
      pageUrl: string;
    };
    SubmitCreditApplicationFormResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "firstName": "John",
     *       "surname": "Doe",
     *       "phone": "1234567890",
     *       "email": "johndoe@test.com",
     *       "accountNo": "12233",
     *       "company": "Hope",
     *       "establishmentType": "School",
     *       "establishmentName": "Abc School",
     *       "city": "Manchester",
     *       "postcode": "M1 1AA",
     *       "acceptTermsOfUse": false,
     *       "formIdentifier": "CreditAppForm",
     *       "pageUrl": "https://example.com/basket"
     *     } */
    SubmitCreditApplicationFormRequest: {
      website: components['schemas']['Website'];
      firstName: string;
      surname: string;
      phone: string;
      /** Format: email */
      email: string;
      accountNo?: string | null;
      company: string;
      establishmentType: string;
      establishmentName: string;
      city: string;
      postcode: string;
      acceptTermsOfUse: boolean;
      formIdentifier: string;
      pageUrl: string;
    };
    SubmitContactUsFormResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "enquiryType": "General Enquiry",
     *       "fullName": "John Smith",
     *       "phoneNumber": "01234567890",
     *       "emailAddress": "john.smith@example.com",
     *       "accountNumber": "12345",
     *       "jobTitle": "Teacher",
     *       "company": "Hope Primary School",
     *       "message": "I would like more information about your products.",
     *       "address": "123 School Lane, Manchester, M1 2AB",
     *       "formIdentifier": "ContactUsForm",
     *       "pageUrl": "https://example.com/contact"
     *     } */
    SubmitContactUsFormRequest: {
      website: components['schemas']['Website'];
      enquiryType: string;
      fullName: string;
      phoneNumber: string;
      /** Format: email */
      emailAddress: string;
      accountNumber?: string | null;
      jobTitle?: string | null;
      company?: string | null;
      message: string;
      address?: string | null;
      formIdentifier: string;
      pageUrl: string;
    };
    GetCustomerTransactionDataResponse: {
      isTransactional: boolean;
      currency: string;
    };
    GetCustomerTransactionDataRequest: Record<string, never>;
    GetCustomerByContactIdResponse: {
      customerDetails?: components['schemas']['User'] | null;
    };
    User: {
      /** Format: int32 */
      userId: number;
      username: string;
      enabled: boolean;
      /** Format: int32 */
      sapContactId: number;
      /** Format: int32 */
      sapBrandId: number;
      /** Format: int32 */
      fbrandId: number;
      changePassword: boolean;
      newsLetterSubscription: boolean;
      contactTitle: string;
      contactForename: string;
      contactSurname: string;
      contactPosition: string;
      telephone: string;
      mobile: string;
      landLine: string;
      preferredNumber: string;
      lastAddressId: string;
      /** Format: date-time */
      dateCreated: string;
      /** Format: date-time */
      dateModified: string;
      /** Format: int32 */
      establishmentId: number;
      accountNo: string;
      accountPaymentMethods: components['schemas']['AccountPaymentMethods'];
      oneClickCheckoutSettings: components['schemas']['OneClickCheckoutSettings'];
      isEmailAuthenticated: boolean;
      webFmsSystem: components['schemas']['WebFMSSystem'];
      receiveEmail: boolean;
      receivePhoneCall: boolean;
      receiveSMS: boolean;
      receivePost: boolean;
      countryCode: string;
      restrictionList: string;
      chatRestoreId: string;
      hasQuotes: boolean;
      isPunchOut: boolean;
      jobRole: string;
      jobRoleName: string;
      department: string;
      departmentName: string;
      orgTypeGroup2: string;
      /** Format: int32 */
      leaCode: number;
      calendarPromptStatus: components['schemas']['CalendarPromptStatus'];
      establishmentType: string;
      landingPage: string;
    };
    AccountPaymentMethods: {
      accountPaymentAllowed: boolean;
      cardPaymentAllowed: boolean;
      payPalPaymentAllowed: boolean;
      adflexPaymentAllowed: boolean;
      simsPaymentAllowed: boolean;
      civicaPaymentAllowed: boolean;
      psFinancialsPaymentAllowed: boolean;
      oraclePaymentAllowed: boolean;
      dunsNumber: string;
      priceGroupCode: string;
      priceGroupDescription: string;
      coreListCode: string;
      coreListDescription: string;
      /** Format: decimal */
      headerDiscount?: number | null;
      webFlowEnabled: boolean;
      webFlowApprover: boolean;
      webFlowBuyer: boolean;
      isBlocked: boolean;
      webFmsSystem: components['schemas']['WebFMSSystem'];
      transactionalCurrency: components['schemas']['TransactionalCurrency'];
      isMandatoryPO: boolean;
    };
    /** @enum {integer} */
    WebFMSSystem: WebFMSSystem;
    /** @enum {integer} */
    TransactionalCurrency: TransactionalCurrency;
    OneClickCheckoutSettings: {
      enabled: boolean;
      preferredAddressId: string;
      preferredDeliveryType?: components['schemas']['DeliveryType'] | null;
      preferredOneClickPaymentType: components['schemas']['OneClickDefaultPaymentType'];
      isValid: boolean;
    };
    /** @enum {integer} */
    DeliveryType: DeliveryType;
    /** @enum {integer} */
    OneClickDefaultPaymentType: OneClickDefaultPaymentType;
    /** @enum {integer} */
    CalendarPromptStatus: CalendarPromptStatus;
    GetCustomerByContactIdRequest: Record<string, never>;
    ConvertOfferResponse: {
      convertedOfferBasketId: string;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 12345,
     *       "offerNo": "98765",
     *       "customerRef": "PO1"
     *     } */
    ConvertOfferRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId: number;
      offerNo: string;
      customerRef: string;
    };
    GetSitemapCategoryListResponse: {
      categoriesList: components['schemas']['SitemapCategory'][];
    };
    SitemapCategory: {
      /** Format: int32 */
      categoryId?: number | null;
      /** Format: int32 */
      parentCategoryId?: number | null;
      fullUrlPath: string;
    };
    GetSitemapCategoryListRequest: Record<string, never>;
    GetCategoryListResponse: {
      categoriesList: components['schemas']['Category'][];
    };
    Category: {
      /** Format: int32 */
      categoryId?: number | null;
      /** Format: int32 */
      parentCategoryId?: number | null;
      categoryName: string;
      /** Format: int32 */
      index?: number | null;
      /** Format: int32 */
      level: number;
      fullUrlPath: string;
      urlSlug: string;
    };
    GetCategoryListRequest: Record<string, never>;
    UpdateOrderLineResponse: {
      message: string;
      updatedOrderLines: components['schemas']['UpdatedOrderLine'][];
    };
    UpdatedOrderLine: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "linesToUpdate": [
     *         {
     *           "itemCode": "HE12345",
     *           "quantity": 1
     *         },
     *         {
     *           "itemCode": "HE67689",
     *           "quantity": 2
     *         }
     *       ],
     *       "contactId": 4999999
     *     } */
    UpdateOrderLineRequest: {
      website: components['schemas']['Website'];
      linesToUpdate: components['schemas']['UpdateOrderLineDetail'][];
      /** Format: int32 */
      contactId?: number | null;
    };
    UpdateOrderLineDetail: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
    };
    ShareBasketResponse: {
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 4999999,
     *       "senderName": "Sender name",
     *       "senderEmail": "Sender@email.com",
     *       "recipientName": "Recipient name",
     *       "recipientEmail": "recipient@email.com",
     *       "message": "This is a test message while sharing basket.",
     *       "countryCode": null
     *     } */
    ShareBasketRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
      senderName: string;
      senderEmail: string;
      recipientName: string;
      recipientEmail: string;
      message?: string | null;
      countryCode?: string | null;
    };
    SetPurchaseOrderNoResponse: {
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "poNumber": "PO123456",
     *       "contactId": 4999999
     *     } */
    SetPurchaseOrderNoRequest: {
      website: components['schemas']['Website'];
      poNumber: string;
      /** Format: int32 */
      contactId?: number | null;
    };
    SetPromoCodeResponse: {
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "promoCode": "50OFF",
     *       "contactId": 4999999
     *     } */
    SetPromoCodeRequest: {
      website: components['schemas']['Website'];
      promoCode: string;
      /** Format: int32 */
      contactId?: number | null;
    };
    SetCheckoutSimsResponse: {
      success: boolean;
      errorMessage?: string | null;
      orderGuid: string;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 123456
     *     } */
    SetCheckoutSimsRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId: number;
    };
    SetCheckoutDataResponse: {
      checkoutId: string;
    };
    /** @example {
     *       "website": 5,
     *       "originSiteUrlData": {
     *         "baseUrl": "https://www.baseurl.com",
     *         "basketPath": "/basket",
     *         "loginPath": "/login",
     *         "orderHistoryPath": "/order-history"
     *       },
     *       "contactId": 123456,
     *       "countryCode": null
     *     } */
    SetCheckoutDataRequest: {
      website: components['schemas']['Website'];
      originSiteUrlData: components['schemas']['OriginSiteUrlData'];
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    OriginSiteUrlData: {
      baseUrl: string;
      basketPath: string;
      loginPath: string;
      orderHistoryPath: string;
    };
    ReplaceOrderLineRequest: {
      website: components['schemas']['Website'];
      lineToReplace: components['schemas']['ReplaceOrderLineDetail'][];
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    ReplaceOrderLineDetail: {
      existingCatalogueRef: string;
      newCatalogueRef: string;
    };
    OrderSimulationStatusToken: {
      taskId: string;
      status: components['schemas']['OrderSimulationStatus'];
      /** Format: guid */
      basketId?: string | null;
      /** Format: int32 */
      contactId: number;
      createdAt: string;
      completedAt: string;
      errorMessage: string;
      discontinuedProducts: components['schemas']['RemovedProduct'][];
    };
    /** @enum {string} */
    OrderSimulationStatus: OrderSimulationStatus;
    RemovedProduct: {
      catalogueRef: string;
      name: string;
      reason: components['schemas']['Reason2'];
    };
    /** @enum {string} */
    Reason2: Reason2;
    OrderSimulateStatusRequest: Record<string, never>;
    OrderSimulateRequestReceivedResponse: {
      taskId: string;
    };
    OrderSimulateRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
    };
    ImportBasketResponse: {
      errorMessage: string;
      invalidItems: components['schemas']['InvalidItemDetails'][];
    };
    /** @example {
     *       "website": 5,
     *       "basketId": "0a6b4632-821e-4e49-9e46-7798c4b13dc8",
     *       "contactId": 4999999,
     *       "countryCode": null
     *     } */
    ImportBasketRequest: {
      website: components['schemas']['Website'];
      /** Format: guid */
      basketId: string;
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    GetBasketExcelFileRequest: Record<string, never>;
    GetBasketResponse: {
      basket: components['schemas']['Basket'];
      taskId?: string | null;
    };
    Basket: {
      /** Format: int32 */
      purchaseOrderId: number;
      /** Format: guid */
      basketId: string;
      /** Format: guid */
      orderGuid: string;
      /** Format: decimal */
      orderTotal: number;
      /** Format: decimal */
      subTotal: number;
      /** Format: decimal */
      taxTotal: number;
      /** Format: decimal */
      discountTotal: number;
      /** Format: decimal */
      shippingTotal: number;
      /** Format: decimal */
      paymentTotal: number;
      promotionCode: components['schemas']['PromoCode'];
      purchaseOrderNumber: string;
      rows: components['schemas']['BasketRow'][];
      /** Format: int32 */
      rowCount: number;
      /** Format: int32 */
      itemCount: number;
      isValidBasket: boolean;
      /** Format: int32 */
      softBasketLimit: number;
      /** Format: int32 */
      hardBasketLimit: number;
      /** Format: decimal */
      currentClassmatesSavings: number;
      /** Format: decimal */
      claimableClassmatesSavings: number;
      currency: string;
      isTransactional?: boolean | null;
    };
    PromoCode: {
      value?: string | null;
      validationMessage?: string | null;
      isValid: boolean;
    };
    BasketRow: {
      itemCode: string;
      productName: string;
      /** Format: decimal */
      price: number;
      /** Format: int32 */
      quantity: number;
      /** Format: decimal */
      discount: number;
      /** Format: decimal */
      vat: number;
      /** Format: decimal */
      total?: number | null;
      isDiscountExcluded: boolean;
    };
    GetBasketRequest: Record<string, never>;
    /** @example {
     *       "website": 5,
     *       "contactId": 4999999
     *     } */
    DeletePurchaseOrderNoRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 4999999
     *     } */
    DeletePromoCodeRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
    };
    /** @example {
     *       "website": 5,
     *       "itemCodes": [
     *         "HE12345",
     *         "HE67689"
     *       ],
     *       "contactId": 4999999
     *     } */
    DeleteOrderLineRequest: {
      website: components['schemas']['Website'];
      itemCodes: string[];
      /** Format: int32 */
      contactId?: number | null;
    };
    CancelBasketRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
    };
    AddQuickOrderToBasketRequest: {
      website: components['schemas']['Website'];
      /** Format: guid */
      quickOrderGuid: string;
      /** Format: int32 */
      contactId?: number | null;
      countryCode?: string | null;
    };
    AddOrderLineResponse: {
      message?: string | null;
      addedOrderLines: components['schemas']['AddedOrderLine'][];
      invalidItems: components['schemas']['InvalidItemDetails'][];
    };
    AddedOrderLine: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
      message?: string | null;
    };
    /** @example {
     *       "website": 5,
     *       "contactId": 4999999,
     *       "items": [
     *         {
     *           "itemCode": "HE12345",
     *           "quantity": 1
     *         },
     *         {
     *           "itemCode": "HE67689",
     *           "quantity": 2
     *         }
     *       ],
     *       "countryCode": null
     *     } */
    AddOrderLineRequest: {
      website: components['schemas']['Website'];
      /** Format: int32 */
      contactId?: number | null;
      items: components['schemas']['AddOrderLineRequestItem'][];
      countryCode?: string | null;
    };
    AddOrderLineRequestItem: {
      itemCode: string;
      /** Format: int32 */
      quantity: number;
    };
    PasswordResetResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "email": "johndoe@gmail.com",
     *       "clientIp": null,
     *       "resetPageUrl": null,
     *       "loginPageUrl": null,
     *       "siteName": null
     *     } */
    PasswordResetRequest: {
      website: components['schemas']['Website'];
      /** Format: email */
      email: string;
      clientIp: string;
      resetPageUrl: string;
      loginPageUrl: string;
      siteName: string;
    };
    PasswordResetSetResponse: {
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "clientIp": null,
     *       "loginPageUrl": null,
     *       "siteName": null,
     *       "passwordNew": null,
     *       "passwordNew2": null,
     *       "validationToken": null
     *     } */
    PasswordResetSetRequest: {
      website: components['schemas']['Website'];
      /** Format: email */
      clientIp: string;
      loginPageUrl: string;
      siteName: string;
      passwordNew: string;
      passwordNew2: string;
      validationToken: string;
    };
    PasswordResetValidateResponse: {
      isValid: boolean;
      isExpired: boolean;
      isConsumed: boolean;
      success: boolean;
      message: string;
    };
    /** @example {
     *       "website": 5,
     *       "validationToken": null
     *     } */
    PasswordResetValidateRequest: {
      website: components['schemas']['Website'];
      validationToken: string;
    };
    /** @example {
     *       "website": 5,
     *       "email": "user@example.com",
     *       "restoreId": "00000000-0000-0000-0000-000000000000"
     *     } */
    SetChatRestoreIdRequest: {
      website: components['schemas']['Website'];
      email: string;
      restoreId: string;
    };
    AuthenticateCustomerResponse: {
      username: string;
      accountNo: string;
      /** Format: int32 */
      sapContactId: number;
      firstName: string;
      lastName: string;
      countryCode: string;
      chatRestoreId: string;
      priceGroupCode: string;
      priceGroupDescription: string;
    };
    /** @example {
     *       "website": 5,
     *       "username": "user@example.com",
     *       "password": "password123"
     *     } */
    AuthenticateCustomerRequest: {
      website: components['schemas']['Website'];
      /** Format: email */
      username: string;
      password: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  GetSmartFlowReportsExcelFile: {
    parameters: {
      query: {
        accountNumbers?: string | null;
        contactIds?: string | null;
        fromDate?: string | null;
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated and retrieved smart flow reports Excel file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/octet-stream': string;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetSmartFlowReports: {
    parameters: {
      query: {
        accountNumbers?: string | null;
        contactIds?: string | null;
        fromDate?: string | null;
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved smart flow reports. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "orders": [
           *         {
           *           "orderHeader": {
           *             "orderId": 123456,
           *             "sapBrandId": null,
           *             "customerRef": null,
           *             "email": "john.doe@test.com",
           *             "username": null,
           *             "contactTitle": null,
           *             "contactForename": "John",
           *             "contactSurname": "Doe",
           *             "accountNo": null,
           *             "sapContactId": 0,
           *             "sapDeliveryAddressId": null,
           *             "promotionCode": null,
           *             "telephoneNumber": null,
           *             "webOrderReference": null,
           *             "sapOrderReference": null,
           *             "deliveryPreference": 0,
           *             "scheduledDeliveryDate": null,
           *             "customerInstructions": null,
           *             "orderStatus": null,
           *             "orderStatusId": 0,
           *             "netOrderValue": 0,
           *             "grossOrderValue": 0,
           *             "promotionValue": 0,
           *             "totalDiscountValue": 0,
           *             "dateCreated": "2025-10-08T13:16:25.3119231Z",
           *             "dateModified": "0001-01-01T00:00:00",
           *             "timestamp": null,
           *             "orderGuid": null,
           *             "orderTypeId": null,
           *             "establishmentName": null,
           *             "contactEmail": null,
           *             "websiteId": null,
           *             "currency": null
           *           },
           *           "orderItems": [
           *             {
           *               "itemCode": "ITEM001",
           *               "description": "Sample Item",
           *               "quantity": 1,
           *               "netLineValue": 10.5,
           *               "grossLineValue": 12.6,
           *               "dateCreated": "0001-01-01T00:00:00"
           *             }
           *           ],
           *           "approvers": [
           *             {
           *               "orderId": null,
           *               "sapContactId": 0,
           *               "emailAddress": "jane.smith@test.com",
           *               "approverName": "Jane Smith",
           *               "dateCreated": "2025-10-08T13:16:25.3121411Z",
           *               "dateAuthorised": null
           *             }
           *           ],
           *           "auditTrail": [
           *             {
           *               "orderId": "123456",
           *               "sapContactId": 0,
           *               "emailAddress": "audit@test.com",
           *               "auditMessage": "Order created",
           *               "dateCreated": "2025-10-08T13:16:25.3122578Z"
           *             }
           *           ]
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetSmartFlowReportsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetTemporaryPassword: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetTemporaryPasswordRequest'];
      };
    };
    responses: {
      /** @description Successfully set and returned a temporary password. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "customerEmail": "example@test.co.uk",
           *       "temporaryPassword": "123ABC"
           *     } */
          'application/json': components['schemas']['SetTemporaryPasswordResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetCustomerReport: {
    parameters: {
      query: {
        searchType: components['schemas']['SearchTypeEnum'];
        searchPhrase: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved customer reports. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "customerReports": [
           *         {
           *           "fbrandID": 1,
           *           "sapContactID": 12345,
           *           "userName": "jdoe",
           *           "name": "John Doe",
           *           "dateContactCreated": "2024-10-08T13:16:25.3173743Z",
           *           "dateContactModified": "2025-10-08T13:16:25.3174101Z",
           *           "establishmentId": 100,
           *           "accountNo": "ACC123",
           *           "contactName": "Jane Smith",
           *           "dateEstablishmentCreated": "2023-10-08T13:16:25.3175479Z",
           *           "dateEstablishmentModified": "2025-09-08T13:16:25.3175668Z"
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetCustomerReportResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetFmsOptions: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully returned a list of FMS options. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "fmsList": [
           *         {
           *           "code": "SIMS",
           *           "name": "Capita SIMS"
           *         },
           *         {
           *           "code": "RM",
           *           "name": "RM Finance"
           *         }
           *       ],
           *       "success": true,
           *       "message": "FMS options retrieved successfully."
           *     } */
          'application/json': components['schemas']['GetFmsOptionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProductReviews: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        page: number;
        perPage: number;
        stars?: number | null;
      };
      header?: never;
      path: {
        itemCode: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The product reviews were successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "reviews": {
           *         "productReviews": [
           *           {
           *             "createdAt": "2025-04-04T14:28:19.964+00:00",
           *             "userFriendlyCreatedDate": "04 Apr 2025",
           *             "stars": 5,
           *             "content": "Post ok. Only stamps required.",
           *             "consumerName": "frank doyle",
           *             "firstCompanyComment": {
           *               "comment": "Thank you for your feedback on the Findel Everyday Multi-Purpose Base - Yellow I’m sorry to hear that this item did not meet your expectations. We appreciate you reaching out to us and I have contacted you by email with some further information on this.",
           *               "createdAt": "2025-04-09T09:52:44.918+00:00",
           *               "userFriendlyCreatedDate": "09 Apr 2025"
           *             },
           *             "attributeRatings": [
           *               {
           *                 "attributeName": "Quality",
           *                 "attributeType": "range_1to5",
           *                 "rating": 5
           *               },
           *               {
           *                 "attributeName": "Value for money",
           *                 "attributeType": "range_1to5",
           *                 "rating": 5
           *               }
           *             ],
           *             "attachments": [
           *               {
           *                 "id": "67f4dfbcca1b146192bfb29f",
           *                 "state": "Published",
           *                 "processedFiles": [
           *                   {
           *                     "dimension": "original",
           *                     "mimeType": "image/jpeg",
           *                     "url": "https://productreviews-attachments.trustpilot.com/67f4dfbcca1b146192bfb29f_original.jpeg"
           *                   },
           *                   {
           *                     "dimension": "360pxWide",
           *                     "mimeType": "image/jpeg",
           *                     "url": "https://productreviews-attachments.trustpilot.com/67f4dfbcca1b146192bfb29f_360pxWide.jpeg"
           *                   }
           *                 ]
           *               }
           *             ]
           *           }
           *         ],
           *         "productReviewSummary": {
           *           "sku": null,
           *           "starsAverage": 4.9,
           *           "numberOfReviews": {
           *             "total": 1,
           *             "oneStar": 0,
           *             "twoStars": 0,
           *             "threeStars": 0,
           *             "fourStars": 0,
           *             "fiveStars": 1
           *           }
           *         }
           *       }
           *     } */
          'application/json': components['schemas']['GetProductReviewsByItemCodeResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The product was not found or has no reviews. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  UpdateQuickOrderItems: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        guid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateQuickOrderItemsRequest'];
      };
    };
    responses: {
      /** @description The quick order was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateQuickOrderItemsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetQuickOrder: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        guid?: string | null;
        contactId?: number | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The quick order was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetQuickOrderResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ClearQuickOrder: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        guid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClearQuickOrderRequest'];
      };
    };
    responses: {
      /** @description The quick order was successfully cleared. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': unknown;
          'application/json': unknown;
        };
      };
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddToQuickOrderFromFile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        guid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['AddToQuickOrderFromFileRequest'];
      };
    };
    responses: {
      /** @description The item(s) were added to the quick order successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AddToQuickOrderFromFileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddQuickOrderItems: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        guid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddQuickOrderItemsRequest'];
      };
    };
    responses: {
      /** @description The item(s) were added to the quick order successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AddQuickOrderItemsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'PunchOut Setup Request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PunchOutSetupRequestRequest'];
      };
    };
    responses: {
      /** @description Successful JSON response containing cXML */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "cXml": "<cXML><!-- Sample successful response --></cXML>",
           *       "success": true
           *     } */
          'application/json': components['schemas']['PunchOutSetupRequestResponse'];
        };
      };
      /** @description Resource not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error or cXML processing failure */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'Save PunchOut Session Token to Purchase Order': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        '*/*': components['schemas']['SavePunchOutSessionTokenToPurchaseOrderRequest'];
      };
    };
    responses: {
      /** @description Successfully saved session token to purchase order */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true
           *     } */
          'application/json': components['schemas']['SavePunchOutSessionTokenToPurchaseOrderResponse'];
        };
      };
      /** @description Invalid request parameters (e.g., invalid basket ID, SAP contact ID, or session token) */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'Update PunchOut basket status to Punched Out': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        '*/*': components['schemas']['UpdatePunchOutBasketStatusRequest'];
      };
    };
    responses: {
      /** @description Successfully updated PunchOut basket to Punched Out and reset the basketid */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true
           *     } */
          'application/json': components['schemas']['UpdatePunchOutBasketStatusResponse'];
        };
      };
      /** @description Invalid request parameters (e.g., invalid website, basket ID or SAP contact ID) */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'Get PunchOut User Details': {
    parameters: {
      query: {
        username: string;
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved punchout user details */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "userName": "",
           *       "accountNo": "",
           *       "sapContactId": 123,
           *       "firstName": "",
           *       "lastName": "",
           *       "countryCode": "GB",
           *       "landingPage": null,
           *       "priceGroupCode": null,
           *       "priceGroupDescription": null,
           *       "isPunchOut": false,
           *       "mapToLimitedUomList": false,
           *       "success": false
           *     } */
          'application/json': components['schemas']['GetPunchOutUserDetailsResponse'];
        };
      };
      /** @description Invalid user details */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'Get PunchOut Session Token': {
    parameters: {
      query: {
        sid: string;
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved session token */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "punchOutSessionToken": {
           *         "id": "eb051a8b-fdf5-4b3e-aece-38ece9c628c7",
           *         "userName": "punchout_user",
           *         "punchOutAdditionalDetails": {
           *           "buyerCookie": "buyer123cookie",
           *           "buyerCredential": {
           *             "identity": "buyer_identity",
           *             "domain": "buyer.example.com",
           *             "sharedSecret": "buyer_shared_secret"
           *           },
           *           "exchangeCredential": {
           *             "identity": "exchange_identity",
           *             "domain": "exchange.example.com",
           *             "sharedSecret": "exchange_shared_secret"
           *           },
           *           "exchangeName": "Sample Exchange",
           *           "exchangeType": 1,
           *           "browserFormPostUrl": "https://example.com/punchout/return",
           *           "shippingDetails": {
           *             "shippingTotal": 15.99,
           *             "shippingTotalVat": 3.2,
           *             "shippingTotalVatStatus": "Taxable"
           *           },
           *           "exitUrl": null
           *         },
           *         "issuedOn": "2025-10-08T13:16:25.6969316Z",
           *         "expiryOn": "2025-10-08T21:16:25.6969317Z"
           *       }
           *     } */
          'application/json': components['schemas']['GetPunchOutSessionTokenResponse'];
        };
      };
      /** @description Invalid session ID */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  'Get PunchOut Order Response': {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        basketId: string;
        contactId: number;
        baseUrl: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful JSON response containing cXML */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "cxml": "<xml></xml>",
           *       "success": true
           *     } */
          'application/json': components['schemas']['GetPunchOutOrderResponseResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Resource not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error or cXML processing failure */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetProductsILove: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetProductsILoveRequest'];
      };
    };
    responses: {
      /** @description Success. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "Successfully added HP00056676 to Products I Love",
           *       "productsILoveCookieValues": null
           *     } */
          'application/json': components['schemas']['SetProductsILoveResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  MergeProductsILove: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MergeProductsILoveRequest'];
      };
    };
    responses: {
      /** @description Cookie and DB values for PIL have been synced. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true
           *     } */
          'application/json': components['schemas']['MergeProductsILoveResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProductsILove: {
    parameters: {
      query: {
        productsILoveCookieValues?: string[] | null;
        contactId?: number | null;
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "productsILove": [
           *         "HP00056676",
           *         "HE1691854"
           *       ]
           *     } */
          'application/json': components['schemas']['GetProductsILoveResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description User is not logged in and has no logged out PIL cookie */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetSitemapCategoryProducts: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        countryCode?: string | null;
      };
      header?: never;
      path: {
        categoryId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "products": [
           *         {
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "urlPath": "/product/fe123456",
           *           "lastModifiedOn": "0001-01-01T00:00:00",
           *           "changeFrequency": 6
           *         },
           *         {
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "urlPath": "/product/fe754321",
           *           "lastModifiedOn": "0001-01-01T00:00:00",
           *           "changeFrequency": 6
           *         }
           *       ],
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetSitemapCategoryProductsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No products were found for the specified category Id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProductsBySearchPhrase: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        searchPhrase: string;
        facets?: {
          [key: string]: string[];
        } | null;
        facetCount?: number | null;
        sortBy?: string | null;
        offset?: number | null;
        limit: number;
        userAgent?: string | null;
        referrer?: string | null;
        clientIP?: string | null;
        sliUserId?: string | null;
        contactId?: number | null;
        disableAutoCorrect: boolean;
        includeReviews?: boolean | null;
        sliBeacon?: string | null;
        sliPageId?: string | null;
        sliRv?: string | null;
        sliRr?: string | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "sliUserId": "user123",
           *       "totalCount": 2190,
           *       "offset": 0,
           *       "limit": 10,
           *       "facets": [
           *         {
           *           "key": "pb",
           *           "name": "Price Range",
           *           "facetValues": [
           *             {
           *               "key": "01",
           *               "name": "£1 - £5",
           *               "count": 32,
           *               "selected": true
           *             },
           *             {
           *               "key": "06",
           *               "name": "Over £100",
           *               "count": 735,
           *               "selected": false
           *             },
           *             {
           *               "key": "04",
           *               "name": "£20 - £50",
           *               "count": 580,
           *               "selected": false
           *             },
           *             {
           *               "key": "03",
           *               "name": "£10 - £20",
           *               "count": 404,
           *               "selected": false
           *             },
           *             {
           *               "key": "05",
           *               "name": "£50 - £100",
           *               "count": 315,
           *               "selected": false
           *             },
           *             {
           *               "key": "02",
           *               "name": "£5 - £10",
           *               "count": 124,
           *               "selected": false
           *             }
           *           ]
           *         }
           *       ],
           *       "facetSliders": null,
           *       "products": [
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": null,
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "productId": 98776543,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "imageId": "FE754321/image.jpg",
           *           "urlPath": "/product/category/FE754321",
           *           "description": null,
           *           "priceIncVat": 44.19,
           *           "priceExcVat": 32.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 123,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "sortOptions": [
           *         {
           *           "key": "score",
           *           "name": "Most Relevant",
           *           "selected": false
           *         },
           *         {
           *           "key": "globalpop",
           *           "name": "Most Popular",
           *           "selected": false
           *         },
           *         {
           *           "key": "price",
           *           "name": "Price: Low to High",
           *           "selected": false
           *         },
           *         {
           *           "key": "price+rev",
           *           "name": "Price: High to Low",
           *           "selected": false
           *         },
           *         {
           *           "key": "title",
           *           "name": "Name: A to Z",
           *           "selected": true
           *         },
           *         {
           *           "key": "title+rev",
           *           "name": "Name: Z to A",
           *           "selected": false
           *         }
           *       ],
           *       "suggestions": [
           *         "item",
           *         "items",
           *         "item 1",
           *         "item 2"
           *       ],
           *       "spellingSuggestion": "item",
           *       "wasAutoCorrected": false,
           *       "autoCorrectedPhrase": null,
           *       "originalSearchPhrase": null,
           *       "sliMerch": null,
           *       "sliTrackingCode": null,
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetProductsBySearchPhraseResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No products were found for the specified category ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProductsBySearchAutoComplete: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        searchPhrase: string;
        limit: number;
        userAgent?: string | null;
        referrer?: string | null;
        clientIP?: string | null;
        sliUserId?: string | null;
        contactId?: number | null;
        sliBeacon?: string | null;
        sliPageId?: string | null;
        sliRv?: string | null;
        sliRr?: string | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "sliUserId": "user123",
           *       "products": [
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": null,
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": null,
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "productId": 98776543,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "imageId": "FE754321/image.jpg",
           *           "urlPath": "/product/category/FE754321",
           *           "description": null,
           *           "priceIncVat": 44.19,
           *           "priceExcVat": 32.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 123,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": null,
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "searchSuggestions": [
           *         {
           *           "suggestion": "Suggestion 1",
           *           "logUrl": "https://example.com/log/suggestion1"
           *         },
           *         {
           *           "suggestion": "Suggestion 2",
           *           "logUrl": "https://example.com/log/suggestion2"
           *         }
           *       ],
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetProductsBySearchAutoCompleteResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProducts: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        /** @example [
         *       ""
         *     ] */
        itemCodes: string[];
        contactId?: number | null;
        includeReviews?: boolean | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The products were successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "products": [
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": "Example product",
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": null,
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": "Example product",
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetProductsByItemCodesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetProductDetails: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        contactId?: number | null;
        includeReviews?: boolean | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path: {
        itemCode: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The product details were successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "product": {
           *         "imagesList": [],
           *         "media": [],
           *         "reasonsToLove": null,
           *         "hasPriceBreak": false,
           *         "priceBreaks": [],
           *         "priceBreakMinUnits": 0,
           *         "category1Id": 1,
           *         "category2Id": 2,
           *         "category3Id": 3,
           *         "alternativeProducts": null,
           *         "productLessons": {
           *           "lessons": null,
           *           "searchUrl": null,
           *           "additionalLessonCount": 0,
           *           "hasProductLessons": false
           *         },
           *         "metaTagDescription": null,
           *         "productFeatures": [],
           *         "productId": 12345678,
           *         "fbrandProductId": 0,
           *         "itemCode": "FE123456",
           *         "catalogueRef": null,
           *         "productName": "Item 1",
           *         "imageId": "FE123456/image.jpg",
           *         "urlPath": "/product/category/FE123456",
           *         "description": null,
           *         "priceIncVat": 4.19,
           *         "priceExcVat": 3.49,
           *         "wasPriceExcVat": 0,
           *         "wasPriceIncVat": 0,
           *         "savingsPercentage": null,
           *         "isDirectDelivery": false,
           *         "directDeliveryText": null,
           *         "isFavourite": null,
           *         "isContractPrice": false,
           *         "isDiscountPrice": false,
           *         "isRestricted": false,
           *         "isTemporarilyUnavailable": false,
           *         "isUnitPriceDisabled": false,
           *         "isPriceBreakPrice": false,
           *         "brandName": "Example",
           *         "minOrderQuantity": 1,
           *         "baseQuantity": 0,
           *         "roundels": [
           *           {
           *             "name": "Buy More Save More",
           *             "text": "Buy More Save More",
           *             "fileName": "roundel.svg"
           *           }
           *         ],
           *         "stockInfo": {
           *           "stockLevel": 6,
           *           "stockStatus": 1,
           *           "isInStock": true,
           *           "isDelayedStock": false,
           *           "isOutOfStock": false,
           *           "isStockRelevant": true,
           *           "expectedBackInStockMessage": "",
           *           "preOrderDate": "1900-01-01T00:00:00",
           *           "isPreOrder": false,
           *           "isBackInStockNotifyEnabled": false,
           *           "inStockDeliveryMessage": null,
           *           "thirdPartyDirectDeliveryMessage": null
           *         },
           *         "alternativeProductType": 0,
           *         "alternativeSavings": null,
           *         "reviews": {
           *           "productReviews": [
           *             {
           *               "createdAt": "2025-04-04T14:28:19.964+00:00",
           *               "userFriendlyCreatedDate": "04 Apr 2025",
           *               "stars": 5,
           *               "content": "Post ok. Only stamps required.",
           *               "consumerName": "frank doyle",
           *               "firstCompanyComment": {
           *                 "comment": "Thank you for your feedback on the Findel Everyday Multi-Purpose Base - Yellow I’m sorry to hear that this item did not meet your expectations. We appreciate you reaching out to us and I have contacted you by email with some further information on this.",
           *                 "createdAt": "2025-04-09T09:52:44.918+00:00",
           *                 "userFriendlyCreatedDate": "09 Apr 2025"
           *               },
           *               "attributeRatings": [
           *                 {
           *                   "attributeName": "Quality",
           *                   "attributeType": "range_1to5",
           *                   "rating": 5
           *                 },
           *                 {
           *                   "attributeName": "Value for money",
           *                   "attributeType": "range_1to5",
           *                   "rating": 5
           *                 }
           *               ],
           *               "attachments": [
           *                 {
           *                   "id": "67f4dfbcca1b146192bfb29f",
           *                   "state": "Published",
           *                   "processedFiles": [
           *                     {
           *                       "dimension": "original",
           *                       "mimeType": "image/jpeg",
           *                       "url": "https://productreviews-attachments.trustpilot.com/67f4dfbcca1b146192bfb29f_original.jpeg"
           *                     },
           *                     {
           *                       "dimension": "360pxWide",
           *                       "mimeType": "image/jpeg",
           *                       "url": "https://productreviews-attachments.trustpilot.com/67f4dfbcca1b146192bfb29f_360pxWide.jpeg"
           *                     }
           *                   ]
           *                 }
           *               ]
           *             }
           *           ],
           *           "productReviewSummary": {
           *             "sku": null,
           *             "starsAverage": 4.9,
           *             "numberOfReviews": {
           *               "total": 9,
           *               "oneStar": 0,
           *               "twoStars": 0,
           *               "threeStars": 0,
           *               "fourStars": 1,
           *               "fiveStars": 8
           *             }
           *           }
           *         },
           *         "parentFbrandProductId": null,
           *         "sliLogUrl": null,
           *         "isVariant": false,
           *         "isVariantHeader": false,
           *         "variantHeader": null,
           *         "isDiscountExcluded": false,
           *         "variants": null,
           *         "isThirdPartyDDelivery": false,
           *         "currency": null
           *       },
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetProductDetailsByItemCodeResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The product was not found for the specified item code. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetLandingPageProducts: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        facets?: {
          [key: string]: string[];
        } | null;
        facetCount?: number | null;
        sortBy?: string | null;
        offset?: number | null;
        limit: number;
        userAgent?: string | null;
        referrer?: string | null;
        clientIP?: string | null;
        contactId?: number | null;
        includeReviews: boolean;
        sliUserId?: string | null;
        sliBeacon?: string | null;
        sliPageId?: string | null;
        sliRv?: string | null;
        sliRr?: string | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path: {
        landingPageName: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "sliUserId": "user123",
           *       "totalCount": 2190,
           *       "offset": 0,
           *       "limit": 10,
           *       "facets": [
           *         {
           *           "key": "pb",
           *           "name": "Price Range",
           *           "facetValues": [
           *             {
           *               "key": "01",
           *               "name": "£1 - £5",
           *               "count": 32,
           *               "selected": true
           *             },
           *             {
           *               "key": "06",
           *               "name": "Over £100",
           *               "count": 735,
           *               "selected": false
           *             },
           *             {
           *               "key": "04",
           *               "name": "£20 - £50",
           *               "count": 580,
           *               "selected": false
           *             },
           *             {
           *               "key": "03",
           *               "name": "£10 - £20",
           *               "count": 404,
           *               "selected": false
           *             },
           *             {
           *               "key": "05",
           *               "name": "£50 - £100",
           *               "count": 315,
           *               "selected": false
           *             },
           *             {
           *               "key": "02",
           *               "name": "£5 - £10",
           *               "count": 124,
           *               "selected": false
           *             }
           *           ]
           *         }
           *       ],
           *       "facetSliders": null,
           *       "products": [
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": null,
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "productId": 98776543,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "imageId": "FE754321/image.jpg",
           *           "urlPath": "/product/category/FE754321",
           *           "description": null,
           *           "priceIncVat": 44.19,
           *           "priceExcVat": 32.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 123,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "sortOptions": [
           *         {
           *           "key": "score",
           *           "name": "Most Relevant",
           *           "selected": false
           *         },
           *         {
           *           "key": "globalpop",
           *           "name": "Most Popular",
           *           "selected": false
           *         },
           *         {
           *           "key": "price",
           *           "name": "Price: Low to High",
           *           "selected": false
           *         },
           *         {
           *           "key": "price+rev",
           *           "name": "Price: High to Low",
           *           "selected": false
           *         },
           *         {
           *           "key": "title",
           *           "name": "Name: A to Z",
           *           "selected": true
           *         },
           *         {
           *           "key": "title+rev",
           *           "name": "Name: Z to A",
           *           "selected": false
           *         }
           *       ],
           *       "suggestions": null,
           *       "sliTrackingCode": null,
           *       "sliMerch": null,
           *       "landingPageDetails": {
           *         "header": "Example Landing Page",
           *         "metaData": {
           *           "title": "Example Landing Page Title",
           *           "description": "This is an example description for the landing page.",
           *           "robots": {
           *             "index": false,
           *             "follow": false
           *           }
           *         }
           *       },
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetLandingPageProductsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No products were found for the specified landing page. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetCategoryProducts: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        facets?: {
          [key: string]: string[];
        } | null;
        facetCount?: number | null;
        sortBy?: string | null;
        offset?: number | null;
        limit: number;
        userAgent?: string | null;
        referrer?: string | null;
        clientIP?: string | null;
        contactId?: number | null;
        includeReviews?: boolean | null;
        sliUserId?: string | null;
        sliBeacon?: string | null;
        sliPageId?: string | null;
        sliRv?: string | null;
        sliRr?: string | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path: {
        categoryId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "sliUserId": "user123",
           *       "totalCount": 2190,
           *       "offset": 0,
           *       "limit": 10,
           *       "facets": [
           *         {
           *           "key": "pb",
           *           "name": "Price Range",
           *           "facetValues": [
           *             {
           *               "key": "01",
           *               "name": "£1 - £5",
           *               "count": 32,
           *               "selected": true
           *             },
           *             {
           *               "key": "06",
           *               "name": "Over £100",
           *               "count": 735,
           *               "selected": false
           *             },
           *             {
           *               "key": "04",
           *               "name": "£20 - £50",
           *               "count": 580,
           *               "selected": false
           *             },
           *             {
           *               "key": "03",
           *               "name": "£10 - £20",
           *               "count": 404,
           *               "selected": false
           *             },
           *             {
           *               "key": "05",
           *               "name": "£50 - £100",
           *               "count": 315,
           *               "selected": false
           *             },
           *             {
           *               "key": "02",
           *               "name": "£5 - £10",
           *               "count": 124,
           *               "selected": false
           *             }
           *           ]
           *         }
           *       ],
           *       "facetSliders": null,
           *       "products": [
           *         {
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": null,
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "productId": 98776543,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "imageId": "FE754321/image.jpg",
           *           "urlPath": "/product/category/FE754321",
           *           "description": null,
           *           "priceIncVat": 44.19,
           *           "priceExcVat": 32.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 123,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": {
           *             "productReviews": null,
           *             "productReviewSummary": {
           *               "sku": "catalogueRef",
           *               "starsAverage": 4.9,
           *               "numberOfReviews": {
           *                 "total": 9,
           *                 "oneStar": 0,
           *                 "twoStars": 0,
           *                 "threeStars": 0,
           *                 "fourStars": 1,
           *                 "fiveStars": 8
           *               }
           *             }
           *           },
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "sortOptions": [
           *         {
           *           "key": "score",
           *           "name": "Most Relevant",
           *           "selected": false
           *         },
           *         {
           *           "key": "globalpop",
           *           "name": "Most Popular",
           *           "selected": false
           *         },
           *         {
           *           "key": "price",
           *           "name": "Price: Low to High",
           *           "selected": false
           *         },
           *         {
           *           "key": "price+rev",
           *           "name": "Price: High to Low",
           *           "selected": false
           *         },
           *         {
           *           "key": "title",
           *           "name": "Name: A to Z",
           *           "selected": true
           *         },
           *         {
           *           "key": "title+rev",
           *           "name": "Name: Z to A",
           *           "selected": false
           *         }
           *       ],
           *       "suggestions": null,
           *       "sliTrackingCode": null,
           *       "sliMerch": null,
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetCategoryProductsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No products were found for the specified category ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetBasketProductsDetails: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        contactId?: number | null;
        pilCookieValues?: string[] | null;
        countryCode?: string | null;
      };
      header?: never;
      path: {
        purchaseOrderId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of products was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "products": [
           *         {
           *           "imagesList": [],
           *           "media": [],
           *           "reasonsToLove": null,
           *           "hasPriceBreak": false,
           *           "priceBreaks": [],
           *           "priceBreakMinUnits": 0,
           *           "category1Id": 0,
           *           "category2Id": 0,
           *           "category3Id": null,
           *           "alternativeProducts": null,
           *           "productLessons": {
           *             "lessons": null,
           *             "searchUrl": null,
           *             "additionalLessonCount": 0,
           *             "hasProductLessons": false
           *           },
           *           "metaTagDescription": null,
           *           "productFeatures": [],
           *           "productId": 12345678,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE123456",
           *           "catalogueRef": null,
           *           "productName": "Item 1",
           *           "imageId": "FE123456/image.jpg",
           *           "urlPath": "/product/category/FE123456",
           *           "description": "Example description",
           *           "priceIncVat": 4.19,
           *           "priceExcVat": 3.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 6,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": null,
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         },
           *         {
           *           "imagesList": [],
           *           "media": [],
           *           "reasonsToLove": null,
           *           "hasPriceBreak": false,
           *           "priceBreaks": [],
           *           "priceBreakMinUnits": 0,
           *           "category1Id": 0,
           *           "category2Id": 0,
           *           "category3Id": null,
           *           "alternativeProducts": null,
           *           "productLessons": {
           *             "lessons": null,
           *             "searchUrl": null,
           *             "additionalLessonCount": 0,
           *             "hasProductLessons": false
           *           },
           *           "metaTagDescription": null,
           *           "productFeatures": [],
           *           "productId": 98776543,
           *           "fbrandProductId": 0,
           *           "itemCode": "FE754321",
           *           "catalogueRef": null,
           *           "productName": "Item 2",
           *           "imageId": "FE754321/image.jpg",
           *           "urlPath": "/product/category/FE754321",
           *           "description": "Example description",
           *           "priceIncVat": 44.19,
           *           "priceExcVat": 32.49,
           *           "wasPriceExcVat": 0,
           *           "wasPriceIncVat": 0,
           *           "savingsPercentage": null,
           *           "isDirectDelivery": false,
           *           "directDeliveryText": null,
           *           "isFavourite": null,
           *           "isContractPrice": false,
           *           "isDiscountPrice": false,
           *           "isRestricted": false,
           *           "isTemporarilyUnavailable": false,
           *           "isUnitPriceDisabled": false,
           *           "isPriceBreakPrice": false,
           *           "brandName": "Example",
           *           "minOrderQuantity": 1,
           *           "baseQuantity": 0,
           *           "roundels": [
           *             {
           *               "name": "Buy More Save More",
           *               "text": "Buy More Save More",
           *               "fileName": "roundel.svg"
           *             }
           *           ],
           *           "stockInfo": {
           *             "stockLevel": 123,
           *             "stockStatus": 1,
           *             "isInStock": true,
           *             "isDelayedStock": false,
           *             "isOutOfStock": false,
           *             "isStockRelevant": true,
           *             "expectedBackInStockMessage": "",
           *             "preOrderDate": "1900-01-01T00:00:00",
           *             "isPreOrder": false,
           *             "isBackInStockNotifyEnabled": false,
           *             "inStockDeliveryMessage": null,
           *             "thirdPartyDirectDeliveryMessage": null
           *           },
           *           "alternativeProductType": 0,
           *           "alternativeSavings": null,
           *           "reviews": null,
           *           "parentFbrandProductId": null,
           *           "sliLogUrl": null,
           *           "isVariant": false,
           *           "isVariantHeader": false,
           *           "variantHeader": null,
           *           "isDiscountExcluded": false,
           *           "variants": null,
           *           "isThirdPartyDDelivery": false,
           *           "currency": null
           *         }
           *       ],
           *       "currency": null,
           *       "isTransactional": false
           *     } */
          'application/json': components['schemas']['GetBasketProductsDetailsResponse'];
        };
      };
      /** @description No products were found for the specified purchase order ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetInStockNotification: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        itemCode: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetInStockNotificationRequest'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': unknown;
          'application/json': unknown;
        };
      };
      /** @description The notification was successfully setup. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ProcessInStockNotifications: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description In stock notifications were sent successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetShowCalendarPrompt: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
      };
      header?: never;
      path: {
        contactId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Prompt details returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "showPrompt": true,
           *       "content": "Would you like to set up your calendar for the term?",
           *       "confirmURL": "/calendar/setup",
           *       "useShippingTerminology": false
           *     } */
          'application/json': components['schemas']['GetShowCalendarPromptResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No prompt found for this contact. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddUserToNewsletter: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddUserToNewsletterRequest'];
      };
    };
    responses: {
      /** @description Thank you, form submitted successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Thank you, form submitted successfully"
           *     } */
          'application/json': components['schemas']['AddUserToNewsletterResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Resource not found or required data missing. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetUserListsWithProductStatus: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        /** @example [
         *       ""
         *     ] */
        catalogueRefs: string[];
      };
      header?: never;
      path: {
        contactId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Returns lists with only included products. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "userLists": [
           *         {
           *           "listId": 101,
           *           "listName": "Back to School",
           *           "includedCatalogueRefs": [
           *             {
           *               "myListItemId": 5001,
           *               "catalogueRef": "ABC123"
           *             },
           *             {
           *               "myListItemId": 5002,
           *               "catalogueRef": "XYZ789"
           *             }
           *           ]
           *         },
           *         {
           *           "listId": 102,
           *           "listName": "Science Supplies",
           *           "includedCatalogueRefs": [
           *             {
           *               "myListItemId": 5010,
           *               "catalogueRef": "LAB456"
           *             }
           *           ]
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetUserListsWithProductStatusResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description User or lists not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Internal server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetAllMyListsWithItems: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
      };
      header?: never;
      path: {
        contactId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Returns full user lists with products. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "myLists": [
           *         {
           *           "listId": 1,
           *           "listName": "Math Essentials",
           *           "products": [
           *             {
           *               "myListItemId": 2001,
           *               "catalogueRef": "MATH1001",
           *               "quantity": 2
           *             }
           *           ]
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetAllMyListsWithItemsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description User or lists not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Unexpected server error. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeleteMyListItems: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteMyListItemsRequest'];
      };
    };
    responses: {
      /** @description Items were successfully deleted from the my list. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "deletedItems": [
           *         {
           *           "myListId": 1,
           *           "myListItemId": 123
           *         }
           *       ],
           *       "deleteFailedItems": [
           *         {
           *           "myListId": 1,
           *           "myListItemId": 999
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['DeleteMyListItemsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The specified my list or items were not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddToMyList: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddToMyListRequest'];
      };
    };
    responses: {
      /** @description Items were successfully added to the my list. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "newLists": []
           *     } */
          'application/json': components['schemas']['AddToMyListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The my list was not found for the specified my list id and contact id. Or no products were found for the item codes requested */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitOverprintingForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['SubmitOverprintingFormRequest'];
      };
    };
    responses: {
      /** @description The overprinting form was submitted successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "Overprinting request form submitted successfully."
           *     } */
          'application/json': components['schemas']['SubmitOverprintingFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitNpsFeedbackForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitNpsFeedbackFormRequest'];
      };
    };
    responses: {
      /** @description The NPS feedback form was submitted successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "NPS feedback form submitted successfully."
           *     } */
          'application/json': components['schemas']['SubmitNpsFeedbackFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitLeadGenerationForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitLeadGenerationFormRequest'];
      };
    };
    responses: {
      /** @description The lead generation form was submitted successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "Lead generation form submitted successfully."
           *     } */
          'application/json': components['schemas']['SubmitLeadGenerationFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitFmsSetupForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitFmsSetupFormRequest'];
      };
    };
    responses: {
      /** @description The FMS setup form was successfully submitted */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "FMS setup form successfully submitted."
           *     } */
          'application/json': components['schemas']['SubmitFmsSetupFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitCreditApplicationForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitCreditApplicationFormRequest'];
      };
    };
    responses: {
      /** @description The credit application form was submitted successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "Credit application form submitted successfully."
           *     } */
          'application/json': components['schemas']['SubmitCreditApplicationFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SubmitContactUsForm: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitContactUsFormRequest'];
      };
    };
    responses: {
      /** @description The contact us form was submitted successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": true,
           *       "message": "Thank you for your submission"
           *     } */
          'application/json': components['schemas']['SubmitContactUsFormResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetCustomerTransactionData: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        contactId?: number | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Customer transaction data found. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "isTransactional": true,
           *       "currency": "GBP"
           *     } */
          'application/json': components['schemas']['GetCustomerTransactionDataResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No transaction data found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetCustomerByContactId: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
      };
      header?: never;
      path: {
        contactId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Customer found. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "customerDetails": {
           *         "userId": 1001,
           *         "username": "jdoe",
           *         "enabled": true,
           *         "sapContactId": 1001,
           *         "sapBrandId": 1,
           *         "fbrandId": 1,
           *         "changePassword": false,
           *         "newsLetterSubscription": true,
           *         "contactTitle": "Mr.",
           *         "contactForename": "John",
           *         "contactSurname": "Doe",
           *         "contactPosition": "Teacher",
           *         "telephone": "0123456789",
           *         "mobile": null,
           *         "landLine": null,
           *         "preferredNumber": null,
           *         "lastAddressId": null,
           *         "dateCreated": "2025-04-08T13:16:25.8364991Z",
           *         "dateModified": "2025-10-08T13:16:25.8365298Z",
           *         "establishmentId": 123,
           *         "accountNo": "ACC1234",
           *         "accountPaymentMethods": {
           *           "accountPaymentAllowed": false,
           *           "cardPaymentAllowed": false,
           *           "payPalPaymentAllowed": false,
           *           "adflexPaymentAllowed": false,
           *           "simsPaymentAllowed": false,
           *           "civicaPaymentAllowed": false,
           *           "psFinancialsPaymentAllowed": false,
           *           "oraclePaymentAllowed": false,
           *           "dunsNumber": null,
           *           "priceGroupCode": null,
           *           "priceGroupDescription": null,
           *           "coreListCode": null,
           *           "coreListDescription": null,
           *           "headerDiscount": null,
           *           "webFlowEnabled": false,
           *           "webFlowApprover": false,
           *           "webFlowBuyer": false,
           *           "isBlocked": false,
           *           "webFmsSystem": 0,
           *           "transactionalCurrency": 0,
           *           "isMandatoryPO": false
           *         },
           *         "oneClickCheckoutSettings": {
           *           "enabled": false,
           *           "preferredAddressId": null,
           *           "preferredDeliveryType": null,
           *           "preferredOneClickPaymentType": 0,
           *           "isValid": false
           *         },
           *         "isEmailAuthenticated": true,
           *         "webFmsSystem": 0,
           *         "receiveEmail": true,
           *         "receivePhoneCall": false,
           *         "receiveSMS": false,
           *         "receivePost": true,
           *         "countryCode": "GB",
           *         "restrictionList": null,
           *         "chatRestoreId": null,
           *         "hasQuotes": true,
           *         "isPunchOut": false,
           *         "jobRole": "IT",
           *         "jobRoleName": null,
           *         "department": "Admin",
           *         "departmentName": null,
           *         "orgTypeGroup2": "School",
           *         "leaCode": 987,
           *         "calendarPromptStatus": 0,
           *         "establishmentType": "Primary",
           *         "landingPage": "/dashboard"
           *       }
           *     } */
          'application/json': components['schemas']['GetCustomerByContactIdResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Customer not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  Convert: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        '*/*': components['schemas']['ConvertOfferRequest'];
      };
    };
    responses: {
      /** @description The offer was successfully converted and the checkout url has been returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "convertedOfferBasketId": "bb03a11d-d20a-485d-80c3-27a2decb4c63"
           *     } */
          'application/json': components['schemas']['ConvertOfferResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description A problem occurred converting the offer. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SitemapCategory: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of sitemap categories was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "categoriesList": [
           *         {
           *           "categoryId": 1,
           *           "parentCategoryId": null,
           *           "fullUrlPath": "/category-1"
           *         },
           *         {
           *           "categoryId": 2,
           *           "parentCategoryId": 1,
           *           "fullUrlPath": "/category-1/category-2"
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetSitemapCategoryListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No categories were found for the specified website. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetCategory: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        contactId?: number | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The list of categories was successfully retrieved. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "categoriesList": [
           *         {
           *           "categoryId": 1,
           *           "parentCategoryId": null,
           *           "categoryName": "Category 1",
           *           "index": 1,
           *           "level": 1,
           *           "fullUrlPath": "/category-1",
           *           "urlSlug": "category-1"
           *         },
           *         {
           *           "categoryId": 2,
           *           "parentCategoryId": 1,
           *           "categoryName": "Category 2",
           *           "index": 2,
           *           "level": 2,
           *           "fullUrlPath": "/category-1/category-2",
           *           "urlSlug": "category-2"
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['GetCategoryListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description No categories were found for the specified website. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeleteOrderLine: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteOrderLineRequest'];
      };
    };
    responses: {
      /** @description The order lines were successfully deleted from the basket. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  UpdateOrderLine: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateOrderLineRequest'];
      };
    };
    responses: {
      /** @description The order lines were successfully updated. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Order line(s) updated successfully",
           *       "updatedOrderLines": [
           *         {
           *           "itemCode": "HE12345",
           *           "quantity": 1,
           *           "message": null
           *         },
           *         {
           *           "itemCode": "HE67689",
           *           "quantity": 2,
           *           "message": null
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['UpdateOrderLineResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  Share: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareBasketRequest'];
      };
    };
    responses: {
      /** @description Basket shared successfully. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Basket shared successfully."
           *     } */
          'application/json': components['schemas']['ShareBasketResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeletePurchaseOrderNo: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeletePurchaseOrderNoRequest'];
      };
    };
    responses: {
      /** @description The purchase order number was successfully deleted from the basket. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetPurchaseOrderNo: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetPurchaseOrderNoRequest'];
      };
    };
    responses: {
      /** @description The purchase order number was successfully set for the basket. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Purchase order number set successfully"
           *     } */
          'application/json': components['schemas']['SetPurchaseOrderNoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  DeletePromoCode: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeletePromoCodeRequest'];
      };
    };
    responses: {
      /** @description The promo code was successfully deleted from the basket. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetPromoCode: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetPromoCodeRequest'];
      };
    };
    responses: {
      /** @description The promo code was successfully set for the basket. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Promo code set successfully"
           *     } */
          'application/json': components['schemas']['SetPromoCodeResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetCheckoutSims: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetCheckoutSimsRequest'];
      };
    };
    responses: {
      /** @description The data was set correctly, and a GUID was returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": false,
           *       "errorMessage": null,
           *       "orderGuid": "02baaf17-11f1-40fb-a434-0a7d6c156544"
           *     } */
          'application/json': components['schemas']['SetCheckoutSimsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetCheckoutData: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetCheckoutDataRequest'];
      };
    };
    responses: {
      /** @description The data was set correctly, and a GUID was returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "checkoutId": "af0085f0-a4ed-4b4e-b48f-7bb9ff2fb77d"
           *     } */
          'application/json': components['schemas']['SetCheckoutDataResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  ReplaceOrderLine: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ReplaceOrderLineRequest'];
      };
    };
    responses: {
      /** @description The order lines were successfully replaced. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateOrderLineResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetOrderSimulateStatus: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        taskId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrderSimulationStatusToken'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  OrderSimulate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OrderSimulateRequest'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrderSimulateRequestReceivedResponse'];
        };
      };
    };
  };
  ImportBasket: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketIdToImport: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportBasketRequest'];
      };
    };
    responses: {
      /** @description The import baskets completed successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "errorMessage": null,
           *       "invalidItems": [
           *         {
           *           "catalogueRef": "HE12345",
           *           "reason": 1
           *         },
           *         {
           *           "catalogueRef": "HE54321",
           *           "reason": 1
           *         }
           *       ]
           *     } */
          'application/json': components['schemas']['ImportBasketResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket ID or contact ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetBasketExcelFile: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        basketId: string;
        countryCode: string;
        contactId?: number | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The basket was retuned as an excel file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/octet-stream': string;
        };
      };
      /** @description The basket was not found for the specified basket ID or contact ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  GetBasket: {
    parameters: {
      query: {
        website: components['schemas']['Website'];
        basketId?: string | null;
        contactId?: number | null;
        runOrderSimulation?: boolean | null;
        countryCode?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The basket details were successfully retrieved and any merge baskets completed successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "basket": {
           *         "purchaseOrderId": 12345,
           *         "basketId": "8130665f-cf1a-4544-b121-2a27f8691d3e",
           *         "orderGuid": "8c264800-88fd-4063-961a-418e6477767f",
           *         "orderTotal": 100,
           *         "subTotal": 80,
           *         "taxTotal": 20,
           *         "discountTotal": 5,
           *         "shippingTotal": 10,
           *         "paymentTotal": 95,
           *         "promotionCode": {
           *           "value": "PROMO123",
           *           "validationMessage": "Promotion code is not valid",
           *           "isValid": false
           *         },
           *         "purchaseOrderNumber": "PO123456",
           *         "rows": [
           *           {
           *             "itemCode": "HE12345",
           *             "productName": "Product 1",
           *             "price": 10,
           *             "quantity": 1,
           *             "discount": 0,
           *             "vat": 2,
           *             "total": 12,
           *             "isDiscountExcluded": false
           *           },
           *           {
           *             "itemCode": "HE67689",
           *             "productName": "Product 2",
           *             "price": 20,
           *             "quantity": 2,
           *             "discount": 0,
           *             "vat": 4,
           *             "total": 48,
           *             "isDiscountExcluded": false
           *           }
           *         ],
           *         "rowCount": 2,
           *         "itemCount": 3,
           *         "isValidBasket": false,
           *         "softBasketLimit": 0,
           *         "hardBasketLimit": 0,
           *         "currentClassmatesSavings": 0,
           *         "claimableClassmatesSavings": 0,
           *         "currency": null,
           *         "isTransactional": null
           *       },
           *       "taskId": null
           *     } */
          'application/json': components['schemas']['GetBasketResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket ID or contact ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  Cancel: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CancelBasketRequest'];
      };
    };
    responses: {
      /** @description The basket was successfully cancelled/emptied */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket ID or contact ID. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddQuickOrderToBasket: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddQuickOrderToBasketRequest'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/plain': unknown;
          'application/json': unknown;
        };
      };
      /** @description The order lines were successfully added to the basket. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The basket or quick order was not found. Or no products were found for the item codes requested */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  AddOrderLine: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        basketId: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddOrderLineRequest'];
      };
    };
    responses: {
      /** @description The order lines were successfully added to the basket. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "message": "Order line(s) added successfully",
           *       "addedOrderLines": [
           *         {
           *           "itemCode": "HE12345",
           *           "quantity": 1,
           *           "message": null
           *         },
           *         {
           *           "itemCode": "HE67689",
           *           "quantity": 2,
           *           "message": null
           *         }
           *       ],
           *       "invalidItems": []
           *     } */
          'application/json': components['schemas']['AddOrderLineResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description The basket was not found for the specified basket id and contact id. Or no products were found for the item codes requested */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PasswordReset: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PasswordResetRequest'];
      };
    };
    responses: {
      /** @description Thank you, password reset email sent successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": false,
           *       "message": "Thank you, password reset email sent successfully"
           *     } */
          'application/json': components['schemas']['PasswordResetResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Resource not found or required data missing. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PasswordResetSet: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PasswordResetSetRequest'];
      };
    };
    responses: {
      /** @description Password updated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "success": false,
           *       "message": "Password updated successfully"
           *     } */
          'application/json': components['schemas']['PasswordResetSetResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Resource not found or required data missing. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  PasswordResetValidate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PasswordResetValidateRequest'];
      };
    };
    responses: {
      /** @description Token validated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "isValid": false,
           *       "isExpired": false,
           *       "isConsumed": false,
           *       "success": false,
           *       "message": "Token validated successfully"
           *     } */
          'application/json': components['schemas']['PasswordResetValidateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Resource not found or required data missing. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
  SetChatRestoreId: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetChatRestoreIdRequest'];
      };
    };
    responses: {
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {} */
          'application/json': components['schemas']['SetChatRestoreIdRequest'];
        };
      };
    };
  };
  AuthenticateCustomer: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AuthenticateCustomerRequest'];
      };
    };
    responses: {
      /** @description The customer was successfully authenticated. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          /** @example {
           *       "username": "user@example.com",
           *       "accountNo": "ACC123456",
           *       "sapContactId": 4999999,
           *       "firstName": null,
           *       "lastName": null,
           *       "countryCode": null,
           *       "chatRestoreId": null,
           *       "priceGroupCode": null,
           *       "priceGroupDescription": null
           *     } */
          'application/json': components['schemas']['AuthenticateCustomerResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Authentication failed due to invalid credentials or other reasons. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
      /** @description An internal server error occurred. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/problem+json': components['schemas']['ProblemDetails'];
        };
      };
    };
  };
}
export enum Website {
  None = 'None',
  AtoZSupplies = 'AtoZSupplies',
  DaviesSports = 'DaviesSports',
  FindelEducation = 'FindelEducation',
  GLS = 'GLS',
  HopeEducation = 'HopeEducation',
  FindelInternational = 'FindelInternational',
  LDA = 'LDA',
  PhilipHarris = 'PhilipHarris',
  Punchout = 'Punchout',
  SPA4Schools = 'SPA4Schools',
  InternationalMarketplace = 'InternationalMarketplace',
  EuHu = 'EuHu',
}
export enum SearchTypeEnum {
  None = 'None',
  AccountNumber = 'AccountNumber',
  ContactId = 'ContactId',
  Email = 'Email',
}
export enum ProductMediaType {
  Vimeo = 'Vimeo',
  PDF = 'PDF',
  YouTube = 'YouTube',
  Link = 'Link',
  Jpg = 'Jpg',
  Png = 'Png',
  Doc = 'Doc',
  Docx = 'Docx',
  Xls = 'Xls',
  Xslx = 'Xslx',
  Ppt = 'Ppt',
  Pptx = 'Pptx',
  Odt = 'Odt',
  Ods = 'Ods',
  Odp = 'Odp',
  Txt = 'Txt',
  Tiff = 'Tiff',
}
export enum StockStatus {
  Unknown = 'Unknown',
  InStock = 'InStock',
  DelayedStock = 'DelayedStock',
  OutOfStock = 'OutOfStock',
}
export enum AlternativeProductType {
  None = 'None',
  Classmates = 'Classmates',
  UpSell = 'UpSell',
  Recommended = 'Recommended',
  OutOfStockAlternative = 'OutOfStockAlternative',
}
export enum Reason {
  Restricted = 'Restricted',
  NotFound = 'NotFound',
  IsVariantHeader = 'IsVariantHeader',
  IsTemporarilyUnavailable = 'IsTemporarilyUnavailable',
}
export enum PunchOutExchange {
  None = 0,
  Oracle = 1,
  PECOS = 2,
  Iris = 3,
}
export enum ChangeFrequency {
  Always = 0,
  Hourly = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4,
  Yearly = 5,
  Never = 6,
}
export enum WebFMSSystem {
  None = 0,
  SIMS = 1,
  PSFinancials = 2,
  Civica = 3,
  Oracle = 4,
}
export enum TransactionalCurrency {
  None = 0,
  GBP = 1,
  EUR = 2,
  AED = 3,
}
export enum DeliveryType {
  Standard = 0,
  NextDay = 1,
  Pre9AmDelivery = 2,
  Pre10AmDelivery = 3,
  AmDelivery = 4,
  PmDelivery = 5,
  DelayDelivery = 6,
}
export enum OneClickDefaultPaymentType {
  None = 0,
  Card = 1,
  Account = 2,
  Paypal = 3,
  Adflex = 4,
}
export enum CalendarPromptStatus {
  NoCalendars = 0,
  AllConfirmed = 1,
  PartiallyConfirmed = 2,
}
export enum OrderSimulationStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
}
export enum Reason2 {
  Restricted = 'Restricted',
  NotFound = 'NotFound',
  IsVariantHeader = 'IsVariantHeader',
  ItemWithdrawn = 'ItemWithdrawn',
  ItemDoesNotExist = 'ItemDoesNotExist',
  UnavailableInLocation = 'UnavailableInLocation',
  NoLongerAvailable = 'NoLongerAvailable',
}
